/*
 * controllers/cartController.js
 * Cart Controller
 */

define('app/controllers/cartController',[
    'app/ControllerClass',
    'app/models/systemModel',
    'app/views/cartView',
    'underscore'
], function( ControllerClass, CartModel, CartView, _) {
    function isOrHasRental(webFolioItem){
        //return webFolioItem.ItemClass=="R";
        return webFolioItem.ItemClass=='R'||(webFolioItem.containsItemClasses&&webFolioItem.containsItemClasses['R']&&!webFolioItem.containsItemClasses['I']);

        if (r_si.subTypeById[webFolioItem.ItemId]=='Rental') {
            return true
        }
        if (r_si.subTypeById[webFolioItem.ItemId]=='Package') {
            var packageItem = _.find(r_si[r_si.typeById[webFolioItem.ItemId]][r_si.subTypeById[webFolioItem.ItemId]],function(item){return item.SkiItemId==webFolioItem.ItemId})
            if (packageItem && packageItem.PackageItems && packageItem.PackageItems.PackageItem) {
                packageItem.PackageItems.PackageItem = $.wrapArray(packageItem.PackageItems.PackageItem);
                if (_.any(packageItem.PackageItems.PackageItem,function(item){
                    if (item.ItemCategory.match(app.customization.skiBooking.rentalCategoriesRegex)) {
                        return true
                    }
                }) ) { return true }
            }
        }
        return false
    }
    return window.app.controllers.cartController = $.extend({}, ControllerClass, {
        app:app,
        module:'cart',

        actions:{
            'show':['cartShow'],
            'history':['bookingHistory'],
            'clear':['cartClear'],
            'cancel':['removeItem'],
            'serviceItem':['cartItemSelected'],
            'serviceStaffList':['cartServiceStaffListRequested'],
            'class':['cartClassSelected'],
            'debuganalytics':['debuganalytics'],
            'checkout':['checkout'],
            'ccPayment':['cartCCFormShow'],
            'ccPayResume':['continueCC'],
            'ccPaySubmit':['cartCCFormDo'],
            'cartCheckout':['cartCheckOut'],
            'ppPayment':['cartPPInit'],
            'ppReturn':['cartPPFinalize'],
            'ypPayment':['cartYPInit'],
            'ypSubmit':['cartYPSubmit'],
            'ypReturn':['cartYPFinalize'],
            'paytmPayment':['cartPaytmInit'],
            'paytmReturn':['cartPaytmFinalize'],
            'i4gPayment':['cartI4GInit'],
            'i4gReturn':['cartI4GFinalize'],
            'sqPayment':['cartSQInit'],
            'sqReturn':['cartSQFinalize'],
            '3cPayment':['cart3CInit'],
            '3cReturn':['cart3CFinalize'],
            'fpPayment':['cartFPInit'],
            'fpReturn':['cartFPFinalize'],
            'wpPayment':['cartWPInit'],
            'wpReturn':['cartWPFinalize'],
            'wpReturn3DS':['cartWPFinalize3DS'],
            'setOverride':['setPMSRestrictionOverride'],
            'refundGC':['refundGC'],
            'redeemGC':['redeemGC'],
            'redeemGCApply':['redeemGCApply'],
            'eReg':['eReg']

        },
        init:function () {
            console.log('initializing cart controller');
            app.data.messages = app.data.messages || [];
            this.initialized = true;
        },

        cartShow:function () {
            $.when(
                app.models.systemModel.getData('folioBookings', {}),
                app.customization.features.pmsBooking && app.models.roomsModel.getData('pmsVenues', {})
            )
                .done(function (r_fb,r_pv) {
                    r_fb.WebFolioItemV2 = {};
                    var deferreds = [app.models.systemModel.validatePMSBeforeSpa(), app.models.systemModel.validateGolfBeforeSpa()];
                    var guestsWithSkiBookings = {}
                    
                    $.each(app.data.pmsBookings, function(i,bookedItem) {
                        // folioSpecialServices only on future ones  without specialServices to reduce number of calls
                        if(bookedItem.Future && !bookedItem.specialServices) {
                            var semaphore_pfss = $.Deferred();
                            deferreds.push(semaphore_pfss);
                            app.models.systemModel.getData('folioSpecialServices', {
                                PMSFolioId : bookedItem.PMSFolioId
                            }).done(function(r_pfss){
                                 r_pfss.PMSBookingDetails
                                    && r_pfss.PMSBookingDetails.PMSFolioSpecialService
                                    && (
                                        bookedItem.specialServices = (
                                            $.isArray(r_pfss.PMSBookingDetails.PMSFolioSpecialService )
                                                ? r_pfss.PMSBookingDetails.PMSFolioSpecialService
                                                : [r_pfss.PMSBookingDetails.PMSFolioSpecialService ]
                                            )
                                        )
                                    || (bookedItem.specialServices = []);
                                semaphore_pfss.resolve();
                            }).fail(function(){
                                semaphore_pfss.resolve();
                            })
                        }
                    });
                    
                    if (r_fb.WebFolioItem) {
                        $.each(r_fb.WebFolioItem, function(i,webFolioItem) {
                            if (webFolioItem.Category=="Ski" && webFolioItem.ItemClass == "R" ) {
                                guestsWithSkiBookings[webFolioItem.CustomerId] = guestsWithSkiBookings[webFolioItem.CustomerId] || {}
                                guestsWithSkiBookings[webFolioItem.CustomerId]['folios'] =
                                guestsWithSkiBookings[webFolioItem.CustomerId]['folios'] || []
                                guestsWithSkiBookings[webFolioItem.CustomerId]['folios'].push(webFolioItem.FolioItemId) 
                                app.datal('GuestsWithSkiInCart',guestsWithSkiBookings)
                             
                            }
                            
                            if (webFolioItem.Category=="Ski" && webFolioItem.PkgFolioItemId) {
                              
                                var pkgItem = _.find(r_fb.WebFolioItem,function(x){
                                   return x && x.FolioItemId==webFolioItem.PkgFolioItemId&&x
                                   .FolioId==webFolioItem.FolioId&&x.Category=='Ski'})
                                if (pkgItem) {
                                    pkgItem.packageItems = pkgItem.packageItems || []
                                    pkgItem.packageItems.push(webFolioItem)
                                    pkgItem.containsItemClasses = pkgItem.containsItemClasses || {}
                                    pkgItem.containsItemClasses[webFolioItem.ItemClass] = true;
                                    delete r_fb.WebFolioItem[i]
                                    console.log('rolled up package ski item',webFolioItem)
                                    return
                                }
 
                            }
                            else if(webFolioItem.PackageType=="PI"){
                                var pkgItem = _.find(r_fb.WebFolioItem,function(x,i){return !!x && webFolioItem.ParentItem == x.FolioItemId });
                                if (pkgItem) {
                                    pkgItem.spaPackageItems = pkgItem.spaPackageItems || []
                                    pkgItem.spaPackageItems.push(webFolioItem)
                                    delete r_fb.WebFolioItem[i]
                                }
                            }
                      
                        })
                        
                        r_fb.WebFolioItem = _.compact(r_fb.WebFolioItem);
                      
                        $.each(r_fb.WebFolioItem, function(i,webFolioItem) {
                            if (webFolioItem.Category=="Hotel") {
                                r_fb.WebFolioItem[i].pmsVenue = _.find(r_pv.Venue, function(x){
                                    return x.VenueName == webFolioItem.Location
                                });
                                var semaphore_ss = $.Deferred();
                                deferreds.push(semaphore_ss);
                                app.models.systemModel.getData('specialServices', {
                                    PMSFolioId : webFolioItem.FolioId
                                }).done(function(r_ss){
                                    r_ss.PMSSpecialService
                                        && (
                                            r_fb.WebFolioItem[i].specialServicesAvailable = r_ss.PMSSpecialService
                                            )
                                        || (r_fb.WebFolioItem[i].specialServicesAvailable = [])
                                    semaphore_ss.resolve();
                                }).fail(function(){
                                    semaphore_ss.resolve();
                                });
                                var semaphore_pfss = $.Deferred();
                                deferreds.push(semaphore_pfss);
                                app.models.systemModel.getData('folioSpecialServices', {
                                    PMSFolioId : webFolioItem.FolioId
                                }).done(function(r_pfss){
                                    r_pfss.PMSBookingDetails
                                        && r_pfss.PMSBookingDetails
                                        && r_pfss.PMSBookingDetails.PMSFolioSpecialService
                                        && (
                                            r_fb.WebFolioItem[i].specialServices = (
                                                $.isArray(r_pfss.PMSBookingDetails.PMSFolioSpecialService )
                                                    ? r_pfss.PMSBookingDetails.PMSFolioSpecialService
                                                    : [r_pfss.PMSBookingDetails.PMSFolioSpecialService ]
                                                )
                                            )
                                        || (r_fb.WebFolioItem[i].specialServices = []);
                                    semaphore_pfss.resolve();
                                }).fail(function(){
                                    semaphore_pfss.resolve();
                                })
                             
                            } else if (webFolioItem.Category=="Ski") {
                                console.log('ski item',webFolioItem)
                                if (app.customization.skiBooking.offerInsuranceOnBookingSummary) {
                                    var ski_params = { 
                                        WebFolioId : app.data.WebFolioId,
                                        CustomerId : webFolioItem.CustomerId, 
                                        StartDate : webFolioItem.StartDate,
                                        Location : webFolioItem.LocationId
                                    }
                                    if (app.customization.skiBooking.queryAdvanceDays) {
                                        var today=Date.today().add(app.customization.skiBooking.allowBookingToday ? 0 : 1).days()
                                        date = Date.parse(app.customization.skiBooking.queryStartDate);
                                        date = (date.valueOf() < today.valueOf() ? today.clone() : date);
                                        ski_params.StartDate=date.toString('yyyy-MM-dd').substr(0,10)+'000000';
                                        var dateEnd = date.clone().add(app.customization.skiBooking.queryAdvanceDays).days();
                                        if (dateEnd.valueOf()<today.valueOf()) {
                                            dateEnd = today.clone()
                                        }
                                        ski_params.EndDate=dateEnd.toString('yyyy-MM-dd')+'000000';
                                        date = date.toString('yyyy-MM-dd');
                                    }
                                    deferreds.push( $.when( !app.models.skiModel.dataModel.skiItems.data || !app.models.skiModel.dataModel.skiItems.data[ app.models.skiModel.makeStandardName(app.models.skiModel.dataModel.skiItems,ski_params) ] 
                                        ? app.models.skiModel.getData('skiItems', ski_params)
                                        : app.models.skiModel.dataModel.skiItems.data[ app.models.skiModel.makeStandardName(app.models.skiModel.dataModel.skiItems,ski_params) ] )
                                    .done(function(r_si){
                                        var insuranceItem;
                                        if (r_si && r_si.InsuranceItems && r_si.InsuranceItems.InsuranceItem) {
                                           insuranceItem=_.find(r_si.InsuranceItems.InsuranceItem,function(item){return item.SkiItemId==webFolioItem.ItemId}) 
                                        }
                                        if (webFolioItem.ItemClass=='I'||(webFolioItem.containsItemClasses&&webFolioItem.containsItemClasses['I'])) {
                                            // if this is an insurance item, look for its parent

                                            var parentWebFolioItem=false;
                                            _.each(r_fb.WebFolioItem,function(folioItem){
                                                if (folioItem && folioItem.Category=="Ski" && folioItem.CustomerId==webFolioItem.CustomerId && folioItem.FolioItemId!=webFolioItem.FolioItemId && isOrHasRental(folioItem)) {
                                                    folioItem.insuranceItem = webFolioItem
                                                    folioItem.insuranceItem.skiItem = insuranceItem
                                                    folioItem.insuranceItem.noRemove = (webFolioItem.containsItemClasses&&webFolioItem.containsItemClasses['I'])
                                                    parentWebFolioItem = true;
                                                }
                                            })
                                            if (parentWebFolioItem && (!webFolioItem.containsItemClasses||(webFolioItem.containsItemClasses&&!webFolioItem.containsItemClasses['I'])) ) {
                                                delete r_fb.WebFolioItem[i]
                                            }
                                        } else {
                                            // this is not an insurance item, but does it have an insurance item? If the null stands at the end, then no.
                                            // also we only consider rental items or packages containing rental items
                                            if (isOrHasRental(webFolioItem)) {
                                                webFolioItem.insuranceItem = webFolioItem.insuranceItem || null
                                                webFolioItem.availableInsurance = r_si && r_si.InsuranceItems && r_si.InsuranceItems.InsuranceItem || []
                                            }
                                            
                                        }
                                    }) )
                                }
                                
                            }

                        });
                        if (app.data.redeemedGCs && app.data.redeemedGCs[app.data.WebFolioId]) {
                            var semaphore_pymts = $.Deferred();
                            deferreds.push(semaphore_pymts);
                            app.data.redeemedGCs[app.data.WebFolioId] = _(app.data.redeemedGCs[app.data.WebFolioId]).filter( function(value) {
                              return !!value
                            })
                            app.models.systemModel.getData('webFolioPayments', {}).done(function(r_wfp){
                                // app.data.redeemedGCs[app.data.WebFolioId] = [];
                                r_wfp.WebFolioPayments
                                    && r_wfp.WebFolioPayments.WebFolioPayment
                                    && _($.wrapArray(r_wfp.WebFolioPayments.WebFolioPayment)).each( function( value, key, list ) {
                                        if (value.GiftCertId) {
                                            var gcData = _(app.data.redeemedGCs[app.data.WebFolioId]).find( function(gc) {
                                                  return value && gc && (value.GiftCertId == gc.GiftCertId)
                                                });
                                            gcData
                                                && $.extend( gcData, value )
                                                || app.data.redeemedGCs[app.data.WebFolioId].push( $.extend(
                                                    {
                                                        GCRedeemedAmount:  value.Amount,
                                                        GCBalance: $.type(value.CardholderName)=='string' ? value.CardholderName.split(/: /)[1] : ''
                                                    }, value ) );
                                            // app.data.redeemedGCs[value.WebFolioId].push(value)
                                        }
                                    })
                                semaphore_pymts.resolve();
                            }).fail(function(){
                                semaphore_pymts.resolve();
                            })
                        }
                    }
                    $.when.apply(this,deferreds).always(function(r_pbs, golfPmsExists){
                        if (r_pbs) {
                            app.data.messages.push({ type:'alert', 'class':'alert-info', actions:[],
                                title:app.localization.spaBooking.pmsbeforespa.notice,
                                message:_.reduce(app.data.spaMissing,function(m,x){
                                    return m
                                        + app.localization.spaBooking.pmsbeforespa.needReservation + " " + x.property + " "
                                        + app.localization.spaBooking.pmsbeforespa.on + " "
                                        + Date.parse(x.date).toString(app.localization.CultureInfo.formatPatterns.longDate) + ". "
                                }, "")
                            });
                            if ((app.data.userLoggedIn&&app.data.spaPropertyIdsInCart) || app.data.pmsBookingFuture) {
                                app.data.messages.push({ type:'alert', 'class':'alert-notice', actions:[],
                                                title: app.localization.spaBooking.pmsbeforespa.acknowledgeTitle,
                                                message: app.localization.spaBooking.pmsbeforespa.acknowledgeIntro,
                                                footer: app.localization.spaBooking.pmsbeforespa.acknowledgeIntroFooter,
                                                actions: [{ text : app.localization.spaBooking.pmsbeforespa.acknowledgeText,
                                                            loading : app.localization.spaBooking.pmsbeforespa.acknowledgeButton,
                                                            label : app.localization.spaBooking.pmsbeforespa.acknowledgeButton,
                                                            url : "#/summary/setOverride" }]
                                            });
                            }
                        } else if (app.data.overridePMSRestriction) {
                            app.data.messages.push({ type:'alert', 'class':'alert-info', actions:[],
                                title:app.localization.spaBooking.pmsbeforespa.noticeOverridden,
                                message:''
                            });
                        } else if(!golfPmsExists) {
                            app.data.messages.push({ type:'alert', 'class':'alert-info', actions:[],
                                title:app.localization.golf.pmsbeforeGolf.notice,
                                message:_.reduce(app.data.golfMissing,function(m,x){
                                    return m
                                        + app.localization.golf.pmsbeforeGolf.needReservation + " " + x.property + " "
                                        + app.localization.golf.pmsbeforeGolf.on + " "
                                        + Date.parse(x.date).toString(app.localization.CultureInfo.formatPatterns.longDate) + ". "
                                }, "")
                            });
                            if ((app.data.userLoggedIn&&app.data.spaPropertyIdsInCart) || app.data.pmsBookingFuture) {
                                app.data.messages.push({ type:'alert', 'class':'alert-notice', actions:[],
                                                title: app.localization.golf.pmsbeforeGolf.acknowledgeTitle,
                                                message: app.localization.golf.pmsbeforeGolf.acknowledgeIntro,
                                                footer: app.localization.golf.pmsbeforeGolf.acknowledgeIntroFooter,
                                                actions: [{ text : app.localization.golf.pmsbeforeGolf.acknowledgeText,
                                                            loading : app.localization.golf.pmsbeforeGolf.acknowledgeButton,
                                                            label : app.localization.golf.pmsbeforeGolf.acknowledgeButton,
                                                            url : "#/summary/setOverride" }]
                                            });
                            }
                        }

                        if (r_fb.WebFolioItem) {
                            $.each(r_fb.WebFolioItem, function(i,webFolioItem) {
                                if (webFolioItem && webFolioItem.insuranceItem === null) {
                                    webFolioItem.needsInsurance = true
                                }
                            })
                            r_fb.WebFolioItem = _.compact(r_fb.WebFolioItem)
                        }
                        // we need group members for privacy mode for golf
                        if((!app.data.groupMembers || !app.data.groupMembers.GroupMember) && app.customization.golfBooking.memberPrivacyMode && app.data.CustomerId && app.data.CustomerGUID){
                            var fetchParams = {
                                CustomerId: app.data.CustomerId,
                                CustomerGUID: app.data.CustomerGUID,
                            }
                            $.when(app.models.userModel.getData('fetchGroupMembers', fetchParams)).always(function (groupMembers) {
                                if(groupMembers && groupMembers.GroupMember){
                                    app.data.groupMembers = groupMembers
                                }
                                app.views.cartView.event.fire('showCartContents', [$.extend(true,{},r_fb),arguments]);
                            });
                        } else {
                            app.views.cartView.event.fire('showCartContents', [$.extend(true,{},r_fb),arguments]);
                        }
                        
                        
                    })



                }).fail(function (r_sl) {
                    alert('Unable to retrieve booking summary.');
                    app.dispatcher.redirect('');
                    // window.location.reload(false);
                });
        },

        bookingHistory:function () {
            $.when(
                app.models.systemModel.validatePMSBeforeSpa()
            )
                .done(function () {
                    app.views.cartView.event.fire('showBookingHistory', []);
                });
        },

        redeemGC:function () {
            if (!app.data.userLoggedIn) {
                app.dispatcher.redirect('profile','login',['next','summary','redeemGC']);
            } else {
                app.views.cartView.event.fire('showRedeemGCForm', []);
            }
        },

        redeemGCApply:function (gcNumber, gcRefNumber, gcType) {
            if (!app.data.userLoggedIn) {
                app.dispatcher.redirect('profile','login',['next','summary','redeemGC']);
            } else {
                // TODO add sanity check for input values here
                if (!gcNumber || !_.contains(['CARD','CERT'],gcType)) {
                    app.dispatcher.redirect('summary', 'redeemGC');
                    return
                }
                $.when(app.models.systemModel.getData('redeemGC', {
                    GCNumber: gcNumber,
                    GCType: gcType,
                    GCRefNumber: gcRefNumber
                }))
                    .done(function (r_rgc) {
                        // semi-persistent storage
                        r_rgc.rawData = undefined;
                        app.data.redeemedGCs = app.data.redeemedGCs || {};
                        app.data.redeemedGCs[app.data.WebFolioId] = app.data.redeemedGCs[app.data.WebFolioId] || [];
                        app.data.redeemedGCs[app.data.WebFolioId].push(r_rgc);
                        app.datal('redeemedGCs',app.data.redeemedGCs);
                        app.data.messages.push({ type:'alert', 'class':'alert-success', actions:[],
                                    title:app.localization.paymentProcessing.gcRedeemedSuccess,
                                    message:''
                                });
                        app.dispatcher.redirect('summary');
                    })
                    .fail(function (r_rgc) {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                    title:app.localization.paymentProcessing.gcRedeemedFailure,
                                    message:r_rgc.Result && app.localization.bookingSummary.err[r_rgc.Result.ErrorId] || ''
                                });
                        app.dispatcher.redirect('summary', 'redeemGC');
                    });

            }
        },

        refundGC:function (gcNumber,skipNavigation) {
            if (!app.data.userLoggedIn) {
                app.dispatcher.redirect('profile','login',['next','summary']);
            } else {
                // TODO add sanity check for input values here
                if (!gcNumber) {
                    app.dispatcher.redirect('summary', '');
                    return
                }
                return $.when(app.models.systemModel.getData('refundGC', {
                    GiftCertId: gcNumber
                }))
                    .done(function (r_rgc) {
                        // semi-persistent storage
                        r_rgc.rawData = undefined;
                        app.data.redeemedGCs = app.data.redeemedGCs || {};
                        app.data.redeemedGCs[app.data.WebFolioId] = app.data.redeemedGCs[app.data.WebFolioId] || [];
                        _(app.data.redeemedGCs[app.data.WebFolioId]).each( function( value, key ) {
                          if (value.GiftCertId == gcNumber) {
                            delete app.data.redeemedGCs[app.data.WebFolioId][key];
                          }
                        })
                        if (app.data.redeemedGCs[app.data.WebFolioId].length==0) {
                            app.data.redeemedGCs[app.data.WebFolioId] = null;
                        }
                        app.datal('redeemedGCs',app.data.redeemedGCs);
                        !skipNavigation && app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                title:app.localization.paymentProcessing.gcRefundedSuccess,
                                message:''
                            });
                        !skipNavigation && app.dispatcher.redirect('summary');
                    })
                    .fail(function (r_rgc) {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                    title:app.localization.paymentProcessing.gcRefundedFailure,
                                    message:r_rgc.Result.Text
                                });
                        !skipNavigation && app.dispatcher.redirect('summary');
                    });

            }
        },

        cartCCFormShow:function () {
            if (!app.data.userLoggedIn) {
                app.dispatcher.redirect('profile','login',['next','summary','ccPayment']);
            } else {

                $.when(app.models.systemModel.getData('folioBalance', {}))
                    .done(function (r_fb) {
                        app.views.cartView.event.fire('showCCPaymentForm', [r_fb]);
                    })
                    .fail(function (r_fb) {
                        alert('Unable to retrieve cart balance.');
                        app.dispatcher.redirect('');
                        window.location.reload(false);
                    });
            }
        },

        cotinueCC:function () {

            if (app.data.nextLogin) {
                this.cartCCFormShow (app.data.nextLogin.ccnum, app.data.nextLogin.cctype, app.data.nextLogin.ccexmon, app.data.nextLogin.ccexyear, app.data.nextLogin.cccvv, app.data.nextLogin.ccfname, app.data.nextLogin.cclname, app.data.nextLogin.ccaddress1, app.data.nextLogin.ccaddress2, app.data.nextLogin.cccity, app.data.nextLogin.ccstate, app.data.nextLogin.cczip, app.data.nextLogin.cccountry)
                app.data.nextLogin = {}
            } else {
                app.dispatcher.redirect('summary','',[]);
            }
        },

        cartCCFormDo:function (ccnum, cctype, ccexmon, ccexyear, cccvv, ccfname, cclname, ccaddress1, ccaddress2, cccity, ccstate, cczip, cccountry) {
            var cardholder = (typeof ccfname != 'undefined' ? ccfname : '') + ' ' + (typeof cclname != 'undefined' ? cclname : ''),
                expiry = (typeof ccexmon != 'undefined' ? ccexmon : '') + (typeof ccexyear != 'undefined' ? ccexyear : '').substr(2);
            if (!app.data.CustomerId || !app.data.userLoggedIn) {
                app.data.nextLogin = { ccnum:ccnum, cctype:cctype, ccexmon:ccexmon, ccexyear:ccexyear, cccvv:cccvv, ccfname:ccfname, cclname:cclname, ccaddress1:ccaddress1, ccaddress2:ccaddress2, cccity:cccity, ccstate:ccstate, cczip:cczip, cccountry:cccountry };
                app.dispatcher.redirect('profile','login',['next','ccPayResume']);
            } else {
                app.data.nextLogin = {};
                var checkoutDfd = $.Deferred();
                app.controllers.cartController.prepBeforeDoCheckout(checkoutDfd.promise()).always(function(prepSuccess){
                    $.when(app.models.systemModel.getData('processCCPayment', {
                            CardType: typeof cctype != 'undefined' ? cctype : '',
                            CardHolder: cardholder,
                            ExpiryDate: expiry,
                            CVV2: typeof cccvv != 'undefined' ? cccvv : '',
                            PostalCode: typeof cczip != 'undefined' ? cczip : '',
                            CardNumber: typeof ccnum != 'undefined' ? ccnum : '',
                            Address: typeof ccaddress1 != 'undefined' ? ccaddress1 : '',
                            Address2: typeof ccaddress2 != 'undefined' ? ccaddress2 : '',
                            City: typeof cccity != 'undefined' ? cccity : '',
                            CustomerId:  app.data.CustomerId,
                            Country: typeof cccountry != 'undefined' ? cccountry : '',
                            StateProv: typeof ccstate != 'undefined' ? ccstate : '',
                            FName: typeof ccfname != 'undefined' ? ccfname : '',
                            LName: typeof cclname != 'undefined' ? cclname : ''}))
                        .done(function (r_fb) {
                            ccnum = cctype = ccexmon = ccexyear = cccvv = undefined;
                            var newdata = [];
                            app.data.receipt = r_fb.Receipt ? r_fb.Receipt : false;
                            for (var key in app.models.systemModel.dataModel.processCCPayment.data) {
                                if (app.models.systemModel.dataModel.processCCPayment.data.hasOwnProperty(key)) {
                                    newdata.push(app.models.systemModel.dataModel.processCCPayment.data[key]);
                                    app.models.systemModel.dataModel.processCCPayment.data[key] = undefined;
                                }
                            }
                            app.models.systemModel.dataModel.processCCPayment.data = newdata;
                            newdata = undefined;
                            console.log('payment success',app.models.systemModel.dataModel.processCCPayment.data);
                            //r.Result.ErrorId
                            if (prepSuccess) {
                                checkoutDfd.resolve();
                                app.dispatcher.dispatch('summary','cartCheckout',["1"])
                                console.log('pay success',r_fb);
                            }
                        })
                        .fail(function (r_fb) {
                            var message = (r_fb && r_fb.Receipt) ? app.localization.paymentProcessing.receiptHeader + r_fb.Receipt + app.localization.paymentProcessing.receiptFooter
                                                        : (r_fb.Result && r_fb.Result.Text)
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                title:app.localization.paymentProcessing.err.paymentFailed,
                                message: message
                            });
                            app.views.cartView.event.fire('updateMessages', [r_fb]);
                        });
                });
            }
        },

        debuganalytics: function(){
            $.when(
                !app.models.systemModel.dataModel.folioBookings.data
                    ? app.models.systemModel.getData('folioBookings', {})
                    : app.models.systemModel.dataModel.folioBookings.data[
                        app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBookings,{})
                      ],
                false,
                app.models.userModel.getData('fetchCustomerProfile',{CustomerId: app.data.CustomerId, CustomerGUID: app.data.CustomerGUID})

            ).done(function(r_fb,r_bal,customer){
                app.views.cartView.event.fire('showAnalytics', [r_fb, r_bal, customer]);
                app.views.cartView.event.fire('showAnalyticsDebugger', [r_fb, r_bal, customer]);
            })
        },

        prepBeforeDoCheckout: function(doCheckoutPromise) {
            var dfd = $.Deferred();
            app.models.systemModel.validatePMSBeforeSpa().done(function(r_pbs){
                // app.models.systemModel.getData('debugfolio',{Debug: "<![CDATA["+encodeURIComponent('validatePMSBeforeSpa.done: '+JSON.stringify(r_pbs)+')')+"]]>"});
                if (r_pbs) {
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                    title:app.localization.spaBooking.pmsbeforespa.errorMotice,
                                    message:''
                                });
                    app.dispatcher.replace('summary','',[]);
                    dfd.reject(false);
                    return;
                }

                if (!app.data.CustomerId || !app.data.userLoggedIn) {
                    app.dispatcher.redirect('profile','login',['next','summary','checkout']);
                    dfd.reject(false);
                // app.models.systemModel.getData('debugfolio',{Debug: "<![CDATA["+encodeURIComponent("redirect('profile','login',['next','summary','checkout']);")+"]]>"});
                } else {
                    if (app.customization.googleAnalytics) {
                        $.when(
                            !app.models.systemModel.dataModel.folioBookings.data
                                ? app.models.systemModel.getData('folioBookings', {})
                                : app.models.systemModel.dataModel.folioBookings.data[
                                    app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBookings,{})
                                  ],
                            false,
                          app.models.userModel.getData('fetchCustomerProfile',{CustomerId: app.data.CustomerId, CustomerGUID: app.data.CustomerGUID})

                        ).done(function(r_fb,r_bal,customer){
                            dfd.resolve(true);
                            app.dispatcher.replace('summary','checkoutComplete',[])
                            doCheckoutPromise.then(function(){
                                app.views.cartView.event.fire('showAnalytics', [r_fb, r_bal, customer]);
                            })
                        }).fail(function(){
                            dfd.resolve(true); // yes resolve because the calling party shouldn't abort its payment completion just because analytics failed
                            app.dispatcher.replace('summary','checkoutComplete',[])
                        })
                    } else {
                        dfd.resolve(true);
                    }
                }
            })
            .fail(function(){
                dfd.resolve(true);
            });
            return dfd.promise();
        },

        cartCheckOut: function(nostop) {            
            $.when(app.models.systemModel.getData('checkoutFolio',{}))
                .done( function(r_cf){
                    if (app.data.clubBookingInCart) app.datal("clubBookingInCart", false) //if there is a club booking in the cart, it will prevent the user for booking from modules. Thus, it is important to clear that 
                    if( app.data.GuestsWithSkiInCart)  app.datal('GuestsWithSkiInCart',{})

                    app.dispatcher.replace('summary','cartCheckoutComplete',[])

                    $.when(app.models.systemModel.getData('emailWebFolioReceipt',{}))
                        .done( function(r_ewf){
                            if (app.customization.exactTarget.viewReceipt === true) {
                                $.when(app.models.systemModel.getData('getWebFolioReceipt',{}))
                                    .done(function (r_gwf){
                                        app.views.cartView.event.fire('showCCPaymentResult', [r_gwf, true]);
                                        app.models.systemModel.monitorSystemState(1);
                                        app.datac('SessionId',null)
                                        $.cookie('sessionid',null)
                                    })
                                    .fail(function (r_gwf) {
                                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                            title:app.localization.paymentProcessing.err.successButNoEmail,
                                            message:r_gwf.Result.Text
                                        });
                                        app.views.cartView.event.fire('showCCPaymentResult', [r_gwf, true]);
                                        app.models.systemModel.monitorSystemState(1);
                                        app.datac('SessionId',null)
                                        $.cookie('sessionid',null)
                                    });
                            } else {
                                app.views.cartView.event.fire('showCCPaymentResult', [r_ewf]);
                            }
                            app.models.systemModel.monitorSystemState(1);
                            app.datac('SessionId',null)
                            $.cookie('sessionid',null)
                        })
                        .fail(function (r_fb) {
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                title:app.localization.paymentProcessing.err.successButNoEmail,
                                message:r_fb.Result.Text
                            });
                            app.views.cartView.event.fire('showCCPaymentResult', [r_fb]);
                            app.models.systemModel.monitorSystemState(1);
                            app.datac('SessionId',null)
                            $.cookie('sessionid',null)
                        });
                })
                .fail(function (r_fb) {
                    app.dispatcher.replace('summary','cartCheckoutComplete',[])
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                        title:app.localization.paymentProcessing.err.successButNoCheckoutFolio,
                        message:r_fb.Result.Text
                    });
                    app.views.cartView.event.fire('updateMessages', [r_fb]);
                });
        },

        cartClear:function (force) {
            $('#progressIndicator').modal('show');
            var self=this,
                deferreds = [],
                golfBookingFolioset ={}
            $.when(app.models.systemModel.getData('folioBookings', {}))
                .done(function (r_fb) {
                    app.data.redeemedGCs = app.data.redeemedGCs || {};
                    app.data.redeemedGCs[app.data.WebFolioId] = app.data.redeemedGCs[app.data.WebFolioId] || [];
                    _.each(app.data.redeemedGCs[app.data.WebFolioId],function(v,k,l){
                        if (v.GiftCertId) {
                            var semaphore_rgc = $.Deferred();
                            deferreds.push(semaphore_rgc);
                            app.controllers.cartController.refundGC(v.GiftCertId,true)
                                .always(function(){
                                    semaphore_rgc.resolve();
                                });
                        }
                    })

                    var semaphore_ri = $.Deferred()
                    deferreds.push(semaphore_ri);
                    var cancelqueue = []
                    _.each(r_fb.WebFolioItem,function(v,k,l){
                        console.log('cancelall',semaphore_ri,v)
                        if(v.Category == "Golf" && !golfBookingFolioset[v.FolioId] || v.Category != "Golf") { // each golfCancel call removes an entire golf booking. Should only run once per folioId
                            cancelqueue.push([v.Category, v.FolioId, v.FolioItemId,true,'','',v.BookingId])
                        }
                        v.Category == "Golf" ? golfBookingFolioset[v.FolioId] = true : ''                        
                    })
                    var cancelqueuelen = cancelqueue.length
                    function runcancelqueue(q,count) {
                        $('#progressIndicator .modal-body p').html(app.localization.general.progressIndicatorMessage+ " "+ count +"/"+ cancelqueuelen);
                        var cancelsettings = q.pop()
                        self.removeItem.apply(this, cancelsettings)
                            .then(null,function(){return $.Deferred().resolve()})
                            .then(function(){
                                if (q.length>0) {
                                    runcancelqueue(q,count++)
                                } else {
                                    semaphore_ri.resolve()
                                }
                            })

                    }
                    runcancelqueue(cancelqueue,1)

                    $.when.apply(this,deferreds).always(function(){
                            $('#progressIndicator .modal-body p').html(app.localization.general.progressIndicatorMessage);
                            console.log('all cleared');
                            app.datal('spaClassQueue',{})
                            app.datal('user_equipment_not_loggedin',{})
                            app.datal("clubBookingInCart",false) 
                            app.datal('GuestsWithSkiInCart',{}) 
                            if(!!app.data.vueAppRef) {
                                app.data.vueAppRef.$store.commit('emptyReservedTime');
                            }

                            app.dispatcher.redirect('summary');
                        })
                        app.data.BookedEquipmentDetails= {}
                })
                .fail(function (r_sl) {
                    makeNewSession()
                });



            function makeNewSession() {
                if(app.data.alreadyCleared) {
                    force=true;
                }
                app.models.systemModel.getData('createSession', {})
                    .done(function (r_cs) {
                        $.cookie('sessionid', r_cs.SessionId, {expires :Date.now().add(+app.customization.defaultSessionTimeout).minutes()} );
                        app.data.SessionId = r_cs.SessionId;
                        app.datac('userLoggedIn', false);
                        app.datac('WebFolioId', r_cs.WebFolioId);
                        app.datac('DefaultCustomerId', r_cs.DefaultCustomerId);
                        app.datac('CustomerId', undefined);
                        app.datac('CustomerEmail', undefined)
                        app.datac('overridePMSRestriction', undefined);
                        app.models.systemModel.setSelected('createSession', {}, r_cs.WebFolioId);
                        app.models.systemModel.getData('folioBalance', {}).always(function(){
                            app.data.alreadyCleared = true;
                            if (force) {
                                $.cookie('data', null);
                                app.dispatcher.redirect('');
                                window.location.reload(false);
                            } else {
                                app.dispatcher.redirect('summary');
                            }
                        })
                    })
                    .fail(function () {
                        app.data.userLoggedIn = false;
                        app.data.CustomerId = undefined;
                        app.data.CustomerEmail = undefined;
                        app.data.FirstName = undefined;
                        app.data.LastName = undefined;
                        app.data.WebFolioId = undefined;
                        app.data.SessionId = undefined;
                        $.cookie('sessionid', null);
                        app.dispatcher.redirect('');
                        window.location.reload(false);
                    })
            }
        },

        removeItem:function (type, folioId, folioItemId, automatic, doRefundAllGCs,doRefundPromoActivatingItem,waitListId, isFutureBooking, golfPositions) {
            
            var deferreds = [];
            automatic = automatic || false;
            if (app.data.redeemedGCs && _.any(app.data.redeemedGCs[app.data.WebFolioId],function(x) { return x && x.GCRedeemedAmount > 0 })) {
                if (doRefundAllGCs == 1) {
                    _.each(app.data.redeemedGCs[app.data.WebFolioId],function(v,k,l){
                        if (v.GiftCertId) {
                            var semaphore_rgc = $.Deferred();
                            deferreds.push(semaphore_rgc);
                            app.controllers.cartController.refundGC(v.GiftCertId,true)
                                .always(function(){
                                    semaphore_rgc.resolve();
                                });
                        }
                    })
                } else {
                    removeButtonText = _.template(app.localization.paymentProcessing.gcRedeemAutoRemoveButton)({type:type,Localization:app.localization,Customization:app.customization});
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                    title:app.localization.paymentProcessing.gcRedeemAutoRemoveTitle,
                                    message:app.localization.paymentProcessing.gcRedeemAutoRemoveDescription,
                                    actions: [{ text : '',
                                                loading : removeButtonText,
                                                label : removeButtonText,
                                                url : "#/summary/cancel/" + type +"/"+ folioId +"/"+ folioItemId +"/"+ (automatic||'') +"/1"}]
                                });
                    if (automatic) {
                        return $.Deferred(function(dfd){dfd.reject()});
                    } else {
                        app.dispatcher.replace('summary','',[]);
                        return;
                    }
                }

            }
            var dfd = $.Deferred()
            return $.when(
                    ( !app.models.systemModel.dataModel.folioBookings.data
                        ? app.models.systemModel.getData('folioBookings', {})
                        : app.models.systemModel.dataModel.folioBookings.data[
                            app.models.roomsModel.makeStandardName(app.models.systemModel.dataModel.folioBookings,{})
                          ]
                    )
                )
                .then(function(r_fb){
                    var skiAction = "cancelSkiItem",
                        folioItem = _.find(r_fb && r_fb.WebFolioItem || [], function(webFolioItem) {
                        return webFolioItem && webFolioItem.Category == type && webFolioItem.FolioId == folioId && webFolioItem.FolioItemId == folioItemId
                    })
                    // if (folioItem && type=="Ski" && folioItem.ItemClass=="A") {
                    //     skiAction = "cancelSkiPass"
                    // }
                    if (folioItem
                            && folioItem.Category=="ski"
                            && folioItem.PkgFolioItemId
                            && _.find(r_fb.WebFolioItem,function(x){return x.FolioItemId==folioItem.PkgFolioItemId&&x.FolioId==folioItem.FolioId&&x.Category=='Ski'})
                        ) {
                        // If this is an item that's part of a package and the package header is in the web folio, then we don't need to cancel this child item separately
                        return
                    }
                   
                    if (folioItem && type=="Ski" && folioItem.ActivatesPromo=="Y" && doRefundPromoActivatingItem != '1') {
                        removeButtonText = _.template(app.localization.bookingSummary.confirmRemoveSkiActivatesPromoTitle)({type:type,title:folioItem.Details,Localization:app.localization,Customization:app.customization});
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                        title:removeButtonText,
                                        message:app.localization.bookingSummary.confirmRemoveSkiActivatesPromo,
                                        actions: [{ text : '',
                                                    loading : app.localization.bookingSummary.confirmRemoveSkiActivatesPromoButton,
                                                    label : app.localization.bookingSummary.confirmRemoveSkiActivatesPromoButton,
                                                    url : "#/summary/cancel/" + type +"/"+ folioId +"/"+ folioItemId +"/"+ (automatic||'') +"/" + doRefundAllGCs + '/1' }]
                                    });
                        if (automatic) {
                            return $.Deferred(function(dfd){dfd.reject()});
                        } else {
                            app.dispatcher.replace('summary','',[]);
                            return;
                        }
                    }
                    var typeToAppMap = {
                        "Club": "CLUB",
                        "PMSPayment": "PMS",
                        "SPAPayment" : "SPA"
                    }
                    var golfKey = ["GolfBookingsId:position="+ golfPositions];

                    var golfParams =  {GolfFolioItemId: folioItemId};
                    if(isFutureBooking && type == "Golf"){
                        golfParams[golfKey] = folioId;
                    }
                    var golfCall = isFutureBooking && type == "Golf" ? 'cancelFutureGolfBooking' : 'cancelSessionGolfBooking';

                    deferreds.push(
                                (type == "Hotel") ? app.models.systemModel.getData('cancelPMSBooking', {PMSFolioId:folioId}) :
                                (type == "Spa") ? app.models.systemModel.getData('cancelSpaService', {SpaFolioItemId:folioItemId, SpaFolioId:folioId}) :
                                (type == "SpaWait") ? app.models.systemModel.getData('RemoveSpaWaitList', {SpaClassWaitListId:waitListId}) :
                                (type == "Ski") ? app.models.systemModel.getData(skiAction, {SkiFolioItemId:folioItemId, SkiFolioId:folioId}) :
                                (type == "Golf") ? app.models.systemModel.getData(golfCall , golfParams) :
                                (type == "Retail") ? app.models.systemModel.getData('cancelRetailItem', {RetFolioItemId:folioItemId, RetFolioId:folioId}) :
                                (type == "Dining") ? app.models.systemModel.getData('cancelDiningReservation', {Reference:folioId}) :
                                (type == "SPAPayment" || type == "PMSPayment" ||type == "Club") ? app.models.userModel.getData('cancelPayment', {FolioItemId:folioItemId, FolioId:folioId,App:typeToAppMap[type]}):$.Deferred(function(dfd){dfd.reject()})
                    );


                    var when = $.when.apply(this,deferreds);
                    if(app.customization.googleAnalytics){
                        $.when(app.commonViewHelper.fetchFromCache('systemModel', 'folioBookings', {})).always(function(r_fb){
                            triggerCancellations(r_fb);
                        });
                    } else {
                        triggerCancellations();
                    }
                    function triggerCancellations(r_fb){
                        when.done(function (r_cs) {
                            if(app.customization.googleAnalytics && r_fb){
                                app.commonViewHelper.analyticsInit('removeItem', [r_fb, type, folioId, folioItemId, waitListId])
                            }
                            if(type == 'Club'){ 
                                //Club 
                                app.datal("clubBookingInCart",false)
                                automatic || app.dispatcher.redirect('summary','show',[]);
                            } else if(type == "Spa") {
                                // Spa
                                var store = null;
                                if(app.data.vueAppRef) store = app.data.vueAppRef.$store;
                                else if(app.data.modeSelectorVueAppRef) store = app.data.modeSelectorVueAppRef.$store;
                                else if(app.data.optionalClassVueAppRef) store = app.data.optionalClassVueAppRef.$store;
                                else if(app.data.vueLoginAppRef) {
                                    if(!store){
                                        store = app.data.vueLoginAppRef.$store
                                    } else {
                                        store = _.extend(store, app.data.vueLoginAppRef.$store)
                                    }
                                }
                                if(store) {
                                    _.keys(store.state.users).some(function(userId){
                                        return _.keys(store.state.users[userId]).some(function(itemIdWithTS){
                                            var service = store.state.users[userId][itemIdWithTS] || {};
                                            if(service.SpaFolioItemId &&service.SpaFolioItemId == folioItemId) {
                                                store.commit('removeReservedTime',{ userId: userId, id:itemIdWithTS, dateTime:service.bookingDetails.StartDateTime,FolioItemId:folioItemId });
                                                store.commit('removeSingleService',{ userId:userId, id:itemIdWithTS, specific:true, donotUpdateURL:true });
                                            }
                                        })
                                    })
                                }
                                if(_.find(app.data.cartData.WebFolioItem, function(item){ return item.FolioId === folioId }) || !isFutureBooking){
                                    app.dispatcher.redirect('summary', 'show', []);
                                } else {
                                    //clears existing bookings before rerendering summary
                                    app.models.userModel.dataModel.fetchCustomerSpaBookings.data ={};
                                    app.controllers.initController.initGuestItinerary('fetchCustomerSpaBookings').done(function(){
                                        app.commonViewHelper.showCancellationModal('Spa', app.data.cancellationSpaItem);
                                    }).fail(function(){
                                        app.commonViewHelper.showCancellationModal('Spa', app.data.cancellationSpaItem);
                                    })
                                }
                            } else if((type == "Ski") && app.customization.skiBooking.guestProfileUpdateOnCheckout && app.data.userLoggedIn && app.data.GuestsWithSkiInCart && !_.isEmpty(app.data.GuestsWithSkiInCart)){   
                                // Ski
                                //remove the folioid from that user object.
                                _.each(app.data.GuestsWithSkiInCart,function(details,customerId){
                                    removeFolioPerUser(details,customerId,folioItemId)
                                    if(folioItem && folioItem.packageItems){
                                        _.each(folioItem.packageItems,function(folio){
                                            removeFolioPerUser(details,customerId,folio.FolioItemId)
                                        })
                                    }
                                })
                                function removeFolioPerUser(skiDetailPerUser,customerId,folioItemId){
                                    skiDetailPerUser.folios = _.without(skiDetailPerUser.folios,folioItemId)
                                    _.isEmpty(skiDetailPerUser.folios) ? delete app.data.GuestsWithSkiInCart[customerId]:  app.data.GuestsWithSkiInCart[customerId] = skiDetailPerUser.folios
                                    
                                }
                                app.dispatcher.dispatch('summary', 'show', []);
                            } else if(type === 'Golf') {
                                // Golf
                                app.data.golfBookings = app.data.golfBookings.filter(function(golfBooking) {
                                    return golfBooking.GolfBookingId !== folioId;
                                })
                                if(isFutureBooking){
                                    //clears existing bookings before rerendering summary
                                    app.models.userModel.dataModel.fetchCustomerGolfBookings.data ={};
                                    app.controllers.initController.initGuestItinerary('fetchCustomerGolfBookings').done(function(){
                                        app.commonViewHelper.showCancellationModal('Golf', app.data.cancellationGolfItem)
                                    }).fail(function(){
                                        app.commonViewHelper.showCancellationModal('Golf', app.data.cancellationGolfItem)
                                    });
                                }else{
                                    app.dispatcher.dispatch('summary', 'show', []);
                                }
                            } else if(type === 'Hotel') {
                                // Hotel
                                app.data.pmsBookings = app.data.pmsBookings.filter(function(pmsBooking) {
                                    return pmsBooking.PMSFolioId !== folioId;
                                });
                                if(_.find(app.data.cartData.WebFolioItem, function(item){ return item.FolioId === folioId }) || !isFutureBooking){
                                    app.dispatcher.redirect('summary', 'show', []);
                                } else {
                                    app.commonViewHelper.showCancellationModal('Hotel', app.data.cancellationPmsItem);
                                }
                            } else {
                                //other types
                                app.dispatcher.redirect('summary', 'show', []);
                            }
    
    
                               
                            })
                            .fail(function (r) {
                                app.data.messages.push({
                                    type: 'alert', 'class': 'alert-error', actions: [],
                                    title: app.localization.bookingSummary.clearCartFail,
                                    message: r && r.Result && app.localization.club.err[r.Result.ErrorId] || ''
                                });
                                automatic || app.dispatcher.dispatch('summary','show',[]);
                                // automatic || window.location.reload(false);
                            });
                    }
                    if (automatic) {
                        return when
                    }
                   
                })

        },

        cartPPInit: function () {
            app.models.systemModel.validatePMSBeforeSpa().done(function(r_pbs){
                if (r_pbs) {
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                    title:app.localization.spaBooking.pmsbeforespa.errorMotice,
                                    message:''
                                });
                    app.dispatcher.replace('summary','',[]);
                    return;
                }
                if (!app.customization.paypal.enabled) {
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                    title:app.localization.paymentProcessing.PPNotConfigured,
                                    message:''
                                });
                    app.dispatcher.replace('summary','show',[]);
                    return;
                }
                if (!app.data.userLoggedIn) {
                    app.dispatcher.replace('profile','login',['next','summary','ppPayment']);
                } else {

                    $.when(app.models.systemModel.getData('setupPPPayment', { CustomerId: app.data.CustomerId, Language: {'en-us':'US','fr-ca':'FR','es-sp':'ES'}[app.language] }))
                        .done(function (r_fb) {
                            if (!!r_fb.Token) {
                                app.views.cartView.event.fire('showPPProgressIndicator');
                                location.href = app.customization.paypal.url + r_fb.Token;
                            }
                        })
                        .fail(function (r_fb) {
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                            title:app.localization.paymentProcessing.PPPreError,
                                            message:''
                                        });
                            app.dispatcher.replace('summary','show',[]);
                        });
                }
            });
        },

        cartPPFinalize: function (token, PayerID) {
            if (PayerID=="") {
                app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                title:app.localization.paymentProcessing.PPCanceled,
                                message:''
                            });
                app.dispatcher.replace('summary','show',[]);
                return;
            }
            app.views.cartView.event.fire('processingPPPayment');
            var checkoutDfd = $.Deferred();
            app.controllers.cartController.prepBeforeDoCheckout(checkoutDfd.promise()).always(function(prepSuccess){
                $.when(app.models.systemModel.getData('doPPPayment', {
                    CustomerId: app.data.CustomerId,
                    Token: token,
                    PayerID: PayerID
                }))
                    .done(function (r_fb) {
                        if (prepSuccess) {
                            checkoutDfd.resolve();
                            app.views.cartView.event.fire('showCCPaymentResult', [r_fb]);
                            app.views.cartView.event.fire('showPPProgressIndicator', [app.localization.paymentProcessing.PPPostRedirect]);
                            app.dispatcher.dispatch('summary','cartCheckout',["1"]);
                        }
                    })
                    .fail(function (r_fb) {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                        title:app.localization.paymentProcessing.PPPostError,
                                        message:''
                                    });
                        app.dispatcher.replace('summary','show',[]);
                    });
            });
        },

        cartYPInit: function (mid, mtr,digest,currency,forwardURL,successURL,failURL) {
            if (!app.customization.yespay.enabled) {
                app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                title:app.localization.paymentProcessing.PPNotConfigured,
                                message:''
                            });
                app.dispatcher.replace('summary','show',[]);
                return;
            }
            if (!app.data.userLoggedIn) {
                app.dispatcher.replace('profile','login',['next','summary','ypPayment']);
            } else {
                app.models.systemModel.getData('folioBookings', {})
                    .done(function(r_fb){
                        app.views.cartView.event.fire('redirectYP', [mid,mtr,digest,currency,forwardURL,successURL,failURL,app.models.systemModel.getSelectedValue('folioBalance', 'FolioBalance', {WebFolioId:app.data.WebFolioId, SessionId:app.data.SessionId}),r_fb]);
                    })
            }

        },

        cartPaytmInit: function (forwardURL,request_type,mid,order_id,cust_id,txn_amount,channel_id,industry_type_id,website,mobile_no,email_id,checksumhash,callback_url) {
            if (!app.customization.paytm.enabled ) {
                app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                title:app.localization.paymentProcessing.PPNotConfigured,
                                message:''
                            });
                app.dispatcher.replace('summary','show',[]);
                return;
            }
            if (!app.data.userLoggedIn) {
                app.dispatcher.replace('profile','login',['next','summary','checkout']);
            } else {
                app.models.systemModel.getData('folioBookings', {})
                    .done(function(r_fb){
                        app.views.cartView.event.fire('redirectPaytm', [
                            forwardURL,request_type,mid,order_id,cust_id,txn_amount,channel_id,industry_type_id,website,mobile_no,email_id,checksumhash,callback_url,
                            app.models.systemModel.getSelectedValue('folioBalance', 'FolioBalance', {WebFolioId:app.data.WebFolioId, SessionId:app.data.SessionId}), r_fb
                        ]);
                    })
            }

        },

        cartI4GInit: function (forwardURL,accessBlock,server,allowStoreCard) {
            if (!app.customization.i4go.enabled) {
                app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                title:app.localization.paymentProcessing.PPNotConfigured,
                                message:''
                            });
                app.dispatcher.replace('summary','show',[]);
                return;
            }
            if (!accessBlock || !forwardURL) {
                app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                title:app.localization.paymentProcessing.PPPreError,
                                message:''
                            });
                app.dispatcher.replace('summary','show',[]);
                return;
            }
            if (!app.data.userLoggedIn) {
                app.dispatcher.replace('profile','login',['next','summary','i4gPayment',forwardURL,accessBlock,server,allowStoreCard]);
            } else {
                app.views.cartView.event.fire('redirectI4G', [forwardURL,accessBlock,server,allowStoreCard]);
            }

        },
        cartWPInit: function (forwardURL,WPCustomerId,allowStoreCard) {
            if (!forwardURL) {
                app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                title:app.localization.paymentProcessing.PPPreError,
                                message:''
                            });
                app.dispatcher.replace('summary','show',[]);
                return;
            }
            if (!app.data.userLoggedIn) {
                app.dispatcher.replace('profile','login',['next','summary','wpPayment',forwardURL,WPCustomerId,allowStoreCard]);
            } else {
                app.views.cartView.event.fire('redirectWP', [forwardURL,WPCustomerId,allowStoreCard]);
            }

        },
        cartFPInit: function (forwardURL,allowStoreCard,paymentamount,threedsenabled,applepayenabled,googlepayenabled,samsungpayenabled,paypalenabled) {
            if (!forwardURL) {
                app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                title:app.localization.paymentProcessing.PPPreError,
                                message:''
                            });
                app.dispatcher.replace('summary','show',[]);
                return;
            }
            if (!app.data.userLoggedIn) {
                app.dispatcher.replace('profile','login',['next','summary','wpPayment',forwardURL,allowStoreCard,paymentamount,threedsenabled,applepayenabled,googlepayenabled,samsungpayenabled,paypalenabled]);
            } else {
                app.views.cartView.event.fire('redirectFP', [forwardURL,allowStoreCard,paymentamount,threedsenabled,applepayenabled,googlepayenabled,samsungpayenabled,paypalenabled]);
            }

        },
        cartSQInit: function (applicationId,forwardURL,locationId,threeDSEnabled,paymentAmount,allowStoreCard,currencyCode) {
//             if (!forwardURL) {
//                 app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
//                                 title:app.localization.paymentProcessing.PPPreError,
//                                 message:''
//                             });
//                 app.dispatcher.replace('summary','show',[]);
//                 return;
//             }
            if (!app.data.userLoggedIn) {
                app.dispatcher.replace('profile','login',['next','summary','sqPayment',applicationId,forwardURL,locationId,threeDSEnabled,paymentAmount,allowStoreCard,currencyCode]);
            } else {
                app.views.cartView.event.fire('redirectSQ', [applicationId,forwardURL,locationId,threeDSEnabled,paymentAmount,allowStoreCard,currencyCode]);
            }

        },
        cart3CInit: function (forwardURL,allowStoreCard,paymentAmount,threeDSEnabled,threeCSession) {
            if (!app.data.userLoggedIn) {
                app.dispatcher.replace('profile','login',['next','summary','3cPayment',forwardURL,allowStoreCard,paymentAmount,threeDSEnabled,threeCSession]);
            } else {
                app.views.cartView.event.fire('redirect3C', [forwardURL,allowStoreCard,paymentAmount,threeDSEnabled,threeCSession]);
            }

        },
        cartPaytmFinalize: function (MID, ORDERID, TXNAMOUNT, CURRENCY, TXNID, BANKTXNID, STATUS, RESPCODE, RESPMSG, TXNDATE, GATEWAYNAME, BANKNAME, PAYMENTMODE, CHECKSUMHASH) {
           /*if (STATUS!="TXN_SUCCESS") {
               app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                               title:app.localization.paymentProcessing.PPCanceled,
                               message:''
                           });
               app.dispatcher.replace('summary','show',[]);
               // app.models.systemModel.getData('debugfolio',{Debug: "<![CDATA["+encodeURIComponent('PGTR=="cancel"')+"]]>"});
               return;
           }*/
            app.views.cartView.event.fire('processingPPPayment');
            var params = {
                WebFolioId: app.data.WebFolioId,
                SessionId: app.data.SessionId,
                PAYTMMID: MID,
                PAYTMORDERID: ORDERID,
                PAYTMTXNAMOUNT: TXNAMOUNT,
                PAYTMCURRENCY: CURRENCY,
                PAYTMTXNID: TXNID,
                PAYTMBANKTXNID: BANKTXNID,
                PAYTMSTATUS: STATUS,
                PAYTMRESPCODE: RESPCODE,
                PAYTMRESPMSG: RESPMSG,
                PAYTMTXNDATE: TXNDATE,
                PAYTMGATEWAYNAME: GATEWAYNAME,
                PAYTMBANKNAME: BANKNAME,
                PAYTMPAYMENTMODE: PAYMENTMODE,
                PAYTMCHECKSUMHASH: CHECKSUMHASH
            };

            var checkoutDfd = $.Deferred();
            app.controllers.cartController.prepBeforeDoCheckout(checkoutDfd.promise()).always(function(prepSuccess){
                var actionPromise = null
                if (app.data.calledDoCheckout&&app.data.calledDoCheckout[app.data.WebFolioId]) {
                    if (app.data.calledDoCheckout[app.data.WebFolioId]=='success') {
                        actionPromise = $.Deferred().resolve().promise()
                    } else {
                        actionPromise = $.Deferred().reject().promise()
                    }
                } else {
                    actionPromise = app.models.systemModel.getData('doCheckout', params)
                }
                $.when(actionPromise)
                    .done(function (r_fb) {
                        app.data.calledDoCheckout = app.data.calledDoCheckout || {}
                        app.data.calledDoCheckout[app.data.WebFolioId] = 'success'
                        app.datac('calledDoCheckout', app.data.calledDoCheckout)
                        app.data.receipt = r_fb.Receipt ? r_fb.Receipt : false;
                        checkoutDfd.resolve();
                        if (prepSuccess) {
                            // app.models.systemModel.getData('debugfolio',{Debug: "<![CDATA["+encodeURIComponent('doCheckout.done: ' + JSON.stringify(r_fb))+"]]>"});
                            app.views.cartView.event.fire('showCCPaymentResult', [r_fb]);
                            app.views.cartView.event.fire('showPPProgressIndicator', [app.localization.paymentProcessing.PPPostRedirect]);
                            app.dispatcher.dispatch('summary','cartCheckout',["1"]);
                        }
                    })
                    .fail(function (r_fb) {
                        app.data.calledDoCheckout = app.data.calledDoCheckout || {}
                        app.data.calledDoCheckout[app.data.WebFolioId] = 'fail'
                        app.datac('calledDoCheckout', app.data.calledDoCheckout)
                        // app.models.systemModel.getData('debugfolio',{Debug: "<![CDATA["+encodeURIComponent('doCheckout.fail :' + JSON.stringify(r_fb))+"]]>"});
                        if(r_fb&&r_fb.Result&&r_fb.Result.ErrorId) {
                            var message = (r_fb && r_fb.Receipt) ? app.localization.paymentProcessing.receiptHeader + r_fb.Receipt + app.localization.paymentProcessing.receiptFooter
                                                        : (r_fb.Result && r_fb.Result.Text)
                            var paymentMessage = { message: app.localization.paymentMessages.yespay.defaultFailMessage };
                            params.YPresult = r_fb.Result.ErrorId;
                            paymentMessage.message = _.template(paymentMessage.message)({params:params,Localization:app.localization,Customization:app.customization});
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                                title:paymentMessage.message,
                                                message:message
                                            });
                        } else {
                            var message = (r_fb && r_fb.Receipt) ? app.localization.paymentProcessing.receiptHeader + r_fb.Receipt + app.localization.paymentProcessing.receiptFooter
                                                        : (r_fb.Result && r_fb.Result.Text)
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                                title:app.localization.paymentProcessing.PPPostError,
                                                message:message
                                            });
                        }
                        app.dispatcher.replace('summary','show',[]);
                        // app.models.systemModel.getData('debugfolio',{Debug: "<![CDATA["+encodeURIComponent(paymentMessage.message)+"]]>"});
                    });
            })
        },

        cartYPFinalize: function (PGTR,AUTHID,authCode,message,amount,result,digest,CVVResponse,AVSResponse,postcodeResponse,MTR, subscriptionRef) {
           if (PGTR=="cancel") {
               app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                               title:app.localization.paymentProcessing.PPCanceled,
                               message:''
                           });
               app.dispatcher.replace('summary','show',[]);
               app.models.systemModel.getData('debugfolio',{Debug: "<![CDATA["+encodeURIComponent('YPcancel: '+JSON.stringify(arguments))+"]]>"});
               return;
           }
            app.views.cartView.event.fire('processingPPPayment');
            var params = {
                WebFolioId: app.data.WebFolioId,
                SessionId: app.data.SessionId,
                YPMTR: typeof MTR != "undefined" ? MTR : '',
                YPAUTHID: typeof AUTHID != "undefined" ? AUTHID : '',
                YPauthCode: typeof authCode != "undefined" ? authCode : '',
                YPmessage: typeof message != "undefined" ? message : '',
                YPamount: typeof amount != "undefined" ? amount : '',
                YPresult: typeof result != "undefined" ? result : '',
                YPdigest: typeof digest != "undefined" ? digest : '',
                YPCVVResponse: typeof CVVResponse != "undefined" ? CVVResponse : '',
                YPAVSResponse: typeof AVSResponse != "undefined" ? AVSResponse : '',
                YPpostcodeResponse: typeof postcodeResponse != "undefined" ? postcodeResponse : '',
                YPsubscriptionRef: typeof subscriptionRef != "undefined" ? subscriptionRef : ''
            };
            if (PGTR) {
                params.YPPGTR = PGTR;
            }
            // app.models.systemModel.getData('debugfolio',{Debug: "<![CDATA["+encodeURIComponent('params: '+JSON.stringify(params))+"]]>"});
            /*if (!_.any(app.localization.paymentMessages.yespay.successCodes, function(x){return x==result})) {
                var paymentMessage = _.find(app.localization.paymentMessages.yespay.reponseCodeMessages, function(x){
                    return _.any(x.applicableCodes, function(y){return y==result});
                }) || { message: app.localization.paymentMessages.yespay.defaultFailMessage };
                paymentMessage.message = _.template(paymentMessage.message)({params:params,Localization:app.localization,Customization:app.customization});
                app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                    title:paymentMessage.message,
                                    message:''
                                });
                app.dispatcher.replace('summary','show',[]);
                // app.models.systemModel.getData('debugfolio',{Debug: "<![CDATA["+encodeURIComponent(paymentMessage.message)+"]]>"});
                return;
            }*/
            var checkoutDfd = $.Deferred();
            app.controllers.cartController.prepBeforeDoCheckout(checkoutDfd.promise()).always(function(prepSuccess){
                var actionPromise = null
                if (app.data.calledDoCheckout&&app.data.calledDoCheckout[app.data.WebFolioId]) {
                    if (app.data.calledDoCheckout[app.data.WebFolioId]=='success') {
                        actionPromise = $.Deferred().resolve().promise()
                    } else {
                        actionPromise = $.Deferred().reject().promise()
                    }
                } else {
                    actionPromise = app.models.systemModel.getData('doCheckout', params)
                }
                $.when(actionPromise)
                    .done(function (r_fb) {
                        app.data.calledDoCheckout = app.data.calledDoCheckout || {}
                        app.data.calledDoCheckout[app.data.WebFolioId] = 'success'
                        app.datac('calledDoCheckout', app.data.calledDoCheckout)
                        app.data.receipt = r_fb.Receipt ? r_fb.Receipt : false;
                        checkoutDfd.resolve();
                        if (prepSuccess) {
                            // app.models.systemModel.getData('debugfolio',{Debug: "<![CDATA["+encodeURIComponent('doCheckout.done: ' + JSON.stringify(r_fb))+"]]>"});
                            app.views.cartView.event.fire('showCCPaymentResult', [r_fb]);
                            app.views.cartView.event.fire('showPPProgressIndicator', [app.localization.paymentProcessing.PPPostRedirect]);
                            app.dispatcher.dispatch('summary','cartCheckout',["1"]);
                        }
                    })
                    .fail(function (r_fb) {
                        app.data.calledDoCheckout = app.data.calledDoCheckout || {}
                        app.data.calledDoCheckout[app.data.WebFolioId] = 'fail'
                        app.datac('calledDoCheckout', app.data.calledDoCheckout)
                        // app.models.systemModel.getData('debugfolio',{Debug: "<![CDATA["+encodeURIComponent('doCheckout.fail :' + JSON.stringify(r_fb))+"]]>"});
                        if(r_fb&&r_fb.Result&&r_fb.Result.ErrorId) {
                            var paymentMessage = _.find(app.localization.paymentMessages.yespay.reponseCodeMessages, function(x){
                                return _.any(x.applicableCodes, function(y){return y==r_fb.Result.ErrorId});
                            }) || { message: app.localization.paymentMessages.yespay.defaultFailMessage };
                            params.YPresult = r_fb.Result.ErrorId;
                            paymentMessage.message = _.template(paymentMessage.message)({params:params,Localization:app.localization,Customization:app.customization});
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                                title:paymentMessage.message,
                                                message:''
                                            });
                        } else {
                            var message = (r_fb && r_fb.Receipt) ? app.localization.paymentProcessing.receiptHeader + r_fb.Receipt + app.localization.paymentProcessing.receiptFooter
                                                        : (r_fb.Result && r_fb.Result.Text)
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                                title:app.localization.paymentProcessing.PPPostError,
                                                message:message
                                            });
                        }
                        app.dispatcher.replace('summary','show',[]);
                        // app.models.systemModel.getData('debugfolio',{Debug: "<![CDATA["+encodeURIComponent(paymentMessage.message)+"]]>"});
                    });
            })
        },

        cartI4GFinalize: function (response, uniqueid, cardtype, expmonth, expyear, responsecode, ccname, ccaddress, cczip, responsetext, storeCard, updatingOnFileToken) {
            /*if (response!="SUCCESS") {
                app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                title:app.localization.paymentProcessing.PPPostError,
                                message:''
                            });
                app.dispatcher.replace('summary','show',[]);
                return;
            }*/
         //   
            var checkoutDfd = $.Deferred();
            var actionPromise = null,
                params = {
                    WebFolioId: app.data.WebFolioId,
                    SessionId: app.data.SessionId,
                    i4GoToken: typeof uniqueid != "undefined" ? uniqueid : '',
                    i4GoCardType: typeof cardtype != "undefined" ? cardtype : '',
                    i4GoExpiryMonth: typeof expmonth != "undefined" ? expmonth : '',
                    i4GoExpiryYear: typeof expyear != "undefined" ? expyear : '',
                    i4GoResponse: typeof response != "undefined" ? response : '',
                    i4GoResponseCode: typeof responsecode != "undefined" ? responsecode : '',
                    i4GoResponseText: typeof responsetext != "undefined" ? responsetext : '',
                    Address: typeof ccaddress != "undefined" ? ccaddress : '',
                    CardHolder: typeof ccname != "undefined" ? ccname : '',
                    PostalCode: typeof cczip != "undefined" ? cczip : ''
                }

             storeCard == 'Y' ? params.StoreCard = storeCard: ''
            
            if (updatingOnFileToken) {
                $('#progressIndicator').modal('show');
                actionPromise = app.models.systemModel.getData('doCheckout', params)
                $.when(actionPromise)
                    .done(function (r_fb) {
                     app.views.cartView.event.fire('showPPProgressIndicator', [app.localization.paymentProcessing.updatingOnFileToken]);
                     app.data.messages.push({
                        type: 'alert',
                        'class': 'alert-success',
                        actions: [],
                        title: app.localization.paymentProcessing.SuccessOnFileTokenUpdateTitle,
                        message: ''
                    });
                  
                    }).fail(function (r_fb) {
                        app.data.messages.push({
                            type: 'alert',
                            'class': 'alert-error',
                            actions: [],
                            title: app.localization.paymentProcessing.onFileTokenUpdateError,
                            message: ''
                        });
                    // app.commonViewHelper.showMessages();
                    }).always(function(){
                        $('#progressIndicator').modal('hide');
                        if (app.data.loginNextURL) {
                            app.dispatcher.dispatch.apply(app.dispatcher, app.data.loginNextURL);
                            app.data.loginNextURL = undefined;
                        } else  app.dispatcher.replace('profile', 'details');
                    })
            } else {
                app.views.cartView.event.fire('processingPPPayment');
                app.controllers.cartController.prepBeforeDoCheckout(checkoutDfd.promise()).always(function (prepSuccess) {
                    if (app.data.calledDoCheckout && app.data.calledDoCheckout[app.data.WebFolioId]) {
                        if (app.data.calledDoCheckout[app.data.WebFolioId] == 'success') {
                            actionPromise = $.Deferred().resolve().promise()
                        } else {
                            actionPromise = $.Deferred().reject().promise()
                        }
                    } else {
                        actionPromise = app.models.systemModel.getData('doCheckout', params)
                    }
                    $.when(actionPromise)
                        .done(function (r_fb) {
                            app.data.calledDoCheckout = app.data.calledDoCheckout || {}
                            app.data.calledDoCheckout[app.data.WebFolioId] = 'success'
                            app.datac('calledDoCheckout', app.data.calledDoCheckout)
                            app.data.receipt = r_fb.Receipt ? r_fb.Receipt : false;
                            if (prepSuccess) {
                                checkoutDfd.resolve();
                                app.views.cartView.event.fire('showCCPaymentResult', [r_fb]);
                                app.views.cartView.event.fire('showPPProgressIndicator', [app.localization.paymentProcessing.PPPostRedirect]);
                                app.dispatcher.dispatch('summary', 'cartCheckout', ["1"]);
                            } else {
                                 app.dispatcher.dispatch('summary','show',[]);
                            }
                        })
                        .fail(function (r_fb) {
                            //                         app.data.calledDoCheckout = app.data.calledDoCheckout || {}
                            //                         app.data.calledDoCheckout[app.data.WebFolioId] = 'fail'
                            //                         app.datac('calledDoCheckout', app.data.calledDoCheckout)
                            var message = (r_fb && r_fb.Receipt) ? app.localization.paymentProcessing.receiptHeader + r_fb.Receipt + app.localization.paymentProcessing.receiptFooter :
                                (r_fb.Result && r_fb.Result.Text)
                            app.data.messages.push({
                                type: 'alert',
                                'class': 'alert-error',
                                actions: [],
                                title: app.localization.paymentProcessing.PPPostError,
                                message: message
                            });
                            app.dispatcher.replace('summary', 'show', []);
                        });
                });
            }
        },
        cartSQFinalize: function (nonce, cardData, verificationToken) {
            /*if (response!="SUCCESS") {
                app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                title:app.localization.paymentProcessing.PPPostError,
                                message:''
                            });
                app.dispatcher.replace('summary','show',[]);
                return;
            }*/
            app.views.cartView.event.fire('processingPPPayment');
            var checkoutDfd = $.Deferred();
            app.controllers.cartController.prepBeforeDoCheckout(checkoutDfd.promise()).always(function(prepSuccess){
                var actionPromise = null
                  , params = {
                        WebFolioId: app.data.WebFolioId,
                        SessionId: app.data.SessionId,
                        Nonce:  typeof nonce != "undefined" ? nonce : '',
                        debug: cardData
                    }
                if (verificationToken) {
                    params.VerificationToken = verificationToken
                }
                if (window.localStorage['storeCard'+app.data.WebFolioId] == 'Y') {
                    params.StoreCard = 'Y';
                }
                if (app.data.calledDoCheckout&&app.data.calledDoCheckout[app.data.WebFolioId]) {
                    if (app.data.calledDoCheckout[app.data.WebFolioId]=='success') {
                        actionPromise = $.Deferred().resolve().promise()
                    } else {
                        actionPromise = $.Deferred().reject().promise()
                    }
                } else {
                    actionPromise = app.models.systemModel.getData('doCheckout', params)
                }
                $.when(actionPromise)
                    .done(function (r_fb) {
                        app.data.calledDoCheckout = app.data.calledDoCheckout || {}
                        app.data.calledDoCheckout[app.data.WebFolioId] = 'success'
                        app.datac('calledDoCheckout', app.data.calledDoCheckout)
                        app.data.receipt = r_fb.Receipt ? r_fb.Receipt : false;
                        $.ajax({
                            url: r_fb.Receipt,
                            dataType: "html"
                        }).done(function (data) {
                            app.data.receipt = data;
                        }).fail(function () {
                            app.data.receipt = '<a href="'+app.data.receipt+'" target="_blank">View Receipt</a>';
                        })
                        if (prepSuccess) {
                            checkoutDfd.resolve();
                            app.views.cartView.event.fire('showCCPaymentResult', [r_fb]);
                            app.views.cartView.event.fire('showPPProgressIndicator', [app.localization.paymentProcessing.PPPostRedirect]);
                            app.dispatcher.dispatch('summary','cartCheckout',["1"]);
                        } else {
                            app.dispatcher.dispatch('summary','show',[]);
                        }
                    })
                    .fail(function (r_fb) {
//                         app.data.calledDoCheckout = app.data.calledDoCheckout || {}
//                         app.data.calledDoCheckout[app.data.WebFolioId] = 'fail'
//                         app.datac('calledDoCheckout', app.data.calledDoCheckout)
                        var message = (r_fb && r_fb.Receipt) ? app.localization.paymentProcessing.receiptHeader + r_fb.Receipt + app.localization.paymentProcessing.receiptFooter
                                                        : (r_fb.Result && r_fb.Result.Text)
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                        title:app.localization.paymentProcessing.PPPostError,
                                        message:message
                                    });
                        app.dispatcher.replace('summary','show',[]);
                    });
            });
        },
        cart3CFinalize: function (txID, authorisationCode, threeDSIndicator, scaTransRef, cardHolderName, address, postalCode, merchantRef, updatingOnFileToken) {
            /*
            https://localhost:4567/src/index.html?cartCCEmail=andy%40zarzycki.ca&cartCCTotal=14.41&cartCCFName=Testy&cartCCLName=Tester&cartCCname=Testy+Tester&cartCCaddress=123+Any+Street+OTHER&cartCCaddress2=svdvsd&cartCCcity=vdvsdv&cartCCstate=WV&cartCCzip=sdfsdfsdf&cartCCcountry=GB#/summary/checkout
         https://localhost:4567/js/lib/3Chelper.html?MerchantRef=WEB9498&TxID=6cf0e08f-cfaa-413d-b405-beb327c5b927&TxState=RR
         data: "?MerchantRef=WEB9499&TxID=a567b774-cdb6-4c11-a5a9-8e52cc0a42dd&TxState=RR"
            <TxID></TxID>
         <AuthorisationCode></AuthorisationCode>
         <ThreeDSIndicator></ThreeDSIndicator>
         <SCATransRef></SCATransRef>
         <CardHolderName>?</CardHolderName>
         <!--Optional:
         <Address>?</Address> -->
         <!--Optional:
         <PostalCode>?</PostalCode> -->
         <!--Optional:
         <StoreCard>?</StoreCard> -->
            }*/
            if (txID=="search"&&authorisationCode) {
                var pairs = (authorisationCode+"").replace(/^\?+/, '').split("&"),
                    values = {}
                _.each(pairs,function(pair){
                    var keyval = pair.split("=")
                    values[keyval[0]]=keyval[1]
                })
                txID=values['TxID']||'';
                authorisationCode=values['AuthorisationCode']||'';
                threeDSIndicator=values['3DSIndicator']||'';
                scaTransRef=values['SCATransRef']||'';
                cardHolderName=values['CardHolderName']||'';
                address=values['Address1']||'';
                postalCode=values['PostalCode']||'';
                merchantRef=values['MerchantRef']||'';
            }
            app.views.cartView.event.fire('processingPPPayment');
            var checkoutDfd = $.Deferred();

            var actionPromise = null
            , params = {
                    WebFolioId: app.data.WebFolioId,
                    SessionId: app.data.SessionId,
                    TxID:  txID || '',
                    AuthorisationCode:  authorisationCode || '',
                    ThreeDSIndicator:  threeDSIndicator || '',
                    SCATransRef:  scaTransRef || '',
                    CardHolderName:  cardHolderName || '',
                    Address:  address || '',
                    PostalCode:  postalCode || '',
                    MerchantRef:  merchantRef || '',                        
                }
            if (window.localStorage['storeCard'+app.data.WebFolioId] == 'Y') {
                params.StoreCard = 'Y';
            }

            if (updatingOnFileToken) {
                $('#progressIndicator').modal('show');
                actionPromise = app.models.systemModel.getData('doCheckout', params)
                $.when(actionPromise)
                    .done(function (r_fb) {
                     app.views.cartView.event.fire('showPPProgressIndicator', [app.localization.paymentProcessing.updatingOnFileToken]);
                     app.data.messages.push({
                        type: 'alert',
                        'class': 'alert-success',
                        actions: [],
                        title: app.localization.paymentProcessing.SuccessOnFileTokenUpdateTitle,
                        message: ''
                    });
                  
                    }).fail(function (r_fb) {
                        app.data.messages.push({
                            type: 'alert',
                            'class': 'alert-error',
                            actions: [],
                            title: app.localization.paymentProcessing.onFileTokenUpdateError,
                            message: ''
                        });
                        
                    }).always(function(){
                        $('#progressIndicator').modal('hide');
                        if (app.data.loginNextURL) {
                            app.dispatcher.dispatch.apply(app.dispatcher, app.data.loginNextURL);
                            app.data.loginNextURL = undefined;
                        } else  app.dispatcher.replace('profile', 'details');
                    })
            } else {                
                app.controllers.cartController.prepBeforeDoCheckout(checkoutDfd.promise()).always(function(prepSuccess){
                    if (app.data.calledDoCheckout&&app.data.calledDoCheckout[app.data.WebFolioId]) {
                        if (app.data.calledDoCheckout[app.data.WebFolioId]=='success') {
                            actionPromise = $.Deferred().resolve().promise()
                        } else {
                            actionPromise = $.Deferred().reject().promise()
                        }
                    } else {
                        actionPromise = app.models.systemModel.getData('doCheckout', params)
                    }
                    $.when(actionPromise)
                        .done(function (r_fb) {
                            app.data.calledDoCheckout = app.data.calledDoCheckout || {}
                            app.data.calledDoCheckout[app.data.WebFolioId] = 'success'
                            app.datac('calledDoCheckout', app.data.calledDoCheckout)
                            app.data.receipt = r_fb.Receipt ? r_fb.Receipt : false;
                            if (prepSuccess) {
                                checkoutDfd.resolve();
                                app.views.cartView.event.fire('showCCPaymentResult', [r_fb]);
                                app.views.cartView.event.fire('showPPProgressIndicator', [app.localization.paymentProcessing.PPPostRedirect]);
                                app.dispatcher.dispatch('summary','cartCheckout',["1"]);
                            } else {
                                app.dispatcher.dispatch('summary','show',[]);
                            }
                        })
                        .fail(function (r_fb) {
                            var message = (r_fb && r_fb.Receipt) ? app.localization.paymentProcessing.receiptHeader + r_fb.Receipt + app.localization.paymentProcessing.receiptFooter
                                                            : (r_fb.Result && r_fb.Result.Text)
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                            title:app.localization.paymentProcessing.PPPostError,
                                            message:message
                                        });
                            app.dispatcher.replace('summary','show',[]);
                        });
                });
            } 

        },
        cartFPFinalize: function (dataJSON, updatingOnFileToken,nameOnCard, auth3dsjson) {
            try {
                data = JSON.parse(dataJSON)
                var paymentkey = data.data.paymentKeys[0]
                // var authenticateResponse = _.find(data.data.attributes,function(x){return x.Key=="AuthenticateResponse"})
                // var auth3dsjson = authenticateResponse && authenticateResponse.Value || "";
            } catch (e) {
     
                params = {
                    WebFolioId: app.data.WebFolioId,
                    SessionId: app.data.SessionId,
                    debug: dataJSON,
                    CardHolderName:nameOnCard
                }
                app.models.systemModel.getData('doCheckout', params).always(function () {
                    app.data.messages.push({
                        type: 'alert',
                        'class': 'alert-error',
                        actions: [],
                        title: app.localization.paymentProcessing.PPPreError,
                        message: ''
                    });
                    
                    updatingOnFileToken ? app.commonViewHelper.showMessages() : app.dispatcher.replace('summary', 'show', [])
                })
                return
            }

            var checkoutDfd = $.Deferred(),
                actionPromise = null,
                params = {
                    WebFolioId: app.data.WebFolioId,
                    SessionId: app.data.SessionId,
                    PaymentKey: typeof paymentkey != "undefined" ? paymentkey : '', // longstring3
                    auth3dsjson: typeof auth3dsjson != "undefined" ? "<![CDATA["+auth3dsjson+"]]>" : '', // utilparam3
                    debug: dataJSON,
                    CardHolderName:nameOnCard
                }
               
            if (updatingOnFileToken) {
                $('#progressIndicator').modal('show');
        
                actionPromise = app.models.systemModel.getData('doCheckout', params)
                $.when(actionPromise)
                    .done(function (r_fb) {
                        app.views.cartView.event.fire('showPPProgressIndicator', [app.localization.paymentProcessing.updatingOnFileToken]);
                        app.data.messages.push({
                            type: 'alert',
                            'class': 'alert-success',
                            actions: [],
                            title: app.localization.paymentProcessing.SuccessOnFileTokenUpdateTitle,
                            message: ''
                        });
                    }).fail(function (r_fb) {
                        app.data.messages.push({
                            type: 'alert',
                            'class': 'alert-error',
                            actions: [],
                            title: app.localization.paymentProcessing.onFileTokenUpdateError,
                            message: ''
                        });
                    }).always(function(){
                        $('#progressIndicator').modal('hide');
                        if (app.data.loginNextURL) {
                            app.dispatcher.dispatch.apply(app.dispatcher, app.data.loginNextURL);
                            app.data.loginNextURL = undefined;
                        } else  app.dispatcher.replace('profile', 'details');
                        app.data.updatingOnFileCard = false
                    })
            } else {
                app.views.cartView.event.fire('processingPPPayment');
                app.controllers.cartController.prepBeforeDoCheckout(checkoutDfd.promise()).always(function (prepSuccess) {

                    var storeCard =  (window.localStorage['storeCard' + app.data.WebFolioId]) 
                    storeCard == 'Y' ? params.StoreCard = storeCard:''
                    if (app.data.calledDoCheckout && app.data.calledDoCheckout[app.data.WebFolioId]) {
                        if (app.data.calledDoCheckout[app.data.WebFolioId] == 'success') {
                            actionPromise = $.Deferred().resolve().promise()
                        } else {
                            actionPromise = $.Deferred().reject().promise()
                        }
                    } else {
                        actionPromise = app.models.systemModel.getData('doCheckout', params)
                    }

                    $.when(actionPromise)
                        .done(function (r_fb) {
                            app.data.calledDoCheckout = app.data.calledDoCheckout || {}
                            app.data.calledDoCheckout[app.data.WebFolioId] = 'success'
                            app.datac('calledDoCheckout', app.data.calledDoCheckout)
                            app.data.receipt = r_fb.Receipt ? r_fb.Receipt : false;
                            if (prepSuccess) {
                                checkoutDfd.resolve();
                                app.views.cartView.event.fire('showCCPaymentResult', [r_fb]);
                                app.views.cartView.event.fire('showPPProgressIndicator', [app.localization.paymentProcessing.PPPostRedirect]);
                                app.dispatcher.dispatch('summary', 'cartCheckout', ["1"]);
                            } else {
                                app.dispatcher.dispatch('summary', 'show', []);
                            }
                        })
                        .fail(function (r_fb) {
                        
                            var message = (r_fb && r_fb.Receipt) ? app.localization.paymentProcessing.receiptHeader + r_fb.Receipt + app.localization.paymentProcessing.receiptFooter :
                                (r_fb.Result && r_fb.Result.Text)
                            app.data.messages.push({
                                type: 'alert',
                                'class': 'alert-error',
                                actions: [],
                                title: app.localization.paymentProcessing.PPPostError,
                                message: message
                            });
                            app.dispatcher.replace('summary', 'show', []);
                        });
                });
            }
        },
        cartWPFinalize: function (status, orderKey, paymentStatus, paymentAmount, paymentCurrency, mac, updatingOnFileCard) {
            var actionPromise = null;
            if (orderKey.match(/^\?/) && !paymentStatus && !paymentAmount && !paymentCurrency && !mac) {
                console.log('parseQueryString', orderKey)
                $.each(orderKey.match(/\?[^#]+/).toString().replace(/^\?/, '').split('&'), function (i, segment) {
                    var parts = segment.split('=')
                    switch (parts[0]) {
                        case "orderKey":
                            orderKey = decodeURIComponent(parts[1]);
                            break;
                        case "paymentStatus":
                            paymentStatus = decodeURIComponent(parts[1]);
                            break;
                        case "paymentAmount":
                            paymentAmount = decodeURIComponent(parts[1]);
                            break;
                        case "paymentCurrency":
                            paymentCurrency = decodeURIComponent(parts[1]);
                            break;
                        case "mac2":
                        case "mac":
                            mac = decodeURIComponent(parts[1]);
                            break;
                    }
                })
            }
            var checkoutDfd = $.Deferred(),
                params = {
                    WebFolioId: app.data.WebFolioId,
                    SessionId: app.data.SessionId,
                    WPstatus: status,
                    WPorderKey: orderKey,
                    WPpaymentStatus: paymentStatus,
                    WPpaymentAmount: paymentAmount,
                    WPpaymentCurrency: paymentCurrency,
                    WPmac: mac,
                }
            var storeCard =  (window.localStorage['storeCard' + app.data.WebFolioId]) 
            storeCard == 'Y' ? params.StoreCard = storeCard :''
            delete window.localStorage['storeCard' + app.data.WebFolioId];
            if (updatingOnFileCard) {
                app.views.cartView.event.fire('showPPProgressIndicator', [app.localization.paymentProcessing.updatingOnFileToken]);
                $.when(app.models.systemModel.getData('doCheckout', params))
                    .then(function (r_fb) {
                        $('#progressIndicator').modal('hide');
                        app.data.messages.push({
                            type: 'alert',
                            'class': 'alert-success',
                            actions: [],
                            title: app.localization.paymentProcessing.SuccessOnFileTokenUpdateTitle,
                            message: ''
                        });
                       
                    }).fail(function (r_fb) {

                        app.data.messages.push({
                            type: 'alert',
                            'class': 'alert-error',
                            actions: [],
                            title: app.localization.paymentProcessing.onFileTokenUpdateError,
                            message: ''
                        });
                      
                    }).always(function(){
                        $('#progressIndicator').modal('hide');
                        if (app.data.loginNextURL) {
                            app.dispatcher.redirect.apply(app.dispatcher, app.data.loginNextURL);
                            app.data.loginNextURL = undefined;
                        } else  app.dispatcher.replace('profile', 'details');
                    })

            } else {
                console.log(1641,"r_fllb")
                app.views.cartView.event.fire('processingPPPayment');
                app.controllers.cartController.prepBeforeDoCheckout(checkoutDfd.promise()).always(function (prepSuccess) {
                    if (!actionPromise) {
                        if (app.data.calledDoCheckout && app.data.calledDoCheckout[app.data.WebFolioId]) {
                            if (app.data.calledDoCheckout[app.data.WebFolioId] == 'success') {
                                actionPromise = $.Deferred().resolve().promise()
                            } else {
                                actionPromise = $.Deferred().reject().promise()
                            }
                        } else {
                            actionPromise = app.models.systemModel.getData('doCheckout', params)
                        }
                    }
                    $.when(actionPromise)
                        .done(function (r_fb) {
                            if (r_fb.Token3DS) {
                                app.views.cartView.event.fire('redirect3DS', [r_fb.RedirectURL, [{
                                        name: 'PaReq',
                                        value: r_fb.Token3DS
                                    },
                                    {
                                        name: 'TermUrl',
                                        value: window.location.protocol + '//' + window.location.host + '/WorldPay3DSecure'
                                    },
                                    {
                                        name: 'MD',
                                        value: btoa(JSON.stringify({
                                            CustomerId: app.data.CustomerId,
                                            WebFolioId: app.data.WebFolioId,
                                            SessionId: app.data.SessionId,
                                            UIPathName: window.location.pathname,
                                            Token3DS: r_fb.Token3DS
                                        }))
                                    }
                                ]]);
                            } else {
                                app.data.calledDoCheckout = app.data.calledDoCheckout || {}
                                app.data.calledDoCheckout[app.data.WebFolioId] = 'success'
                                app.datac('calledDoCheckout', app.data.calledDoCheckout)
                                app.data.receipt = r_fb.Receipt ? r_fb.Receipt : false;
                                if (prepSuccess) {
                                    checkoutDfd.resolve();
                                    app.views.cartView.event.fire('showCCPaymentResult', [r_fb]);
                                    app.views.cartView.event.fire('showPPProgressIndicator', [app.localization.paymentProcessing.PPPostRedirect]);
                                    app.dispatcher.dispatch('summary', 'cartCheckout', ["1"]);
                                } else {
                                    app.dispatcher.dispatch('summary', 'show', []);
                                }
                            }
                        })
                        .fail(function (r_fb) {
                            app.data.messages.push({
                                type: 'alert',
                                'class': 'alert-error',
                                actions: [],
                                title: app.localization.paymentProcessing.PPPostError,
                                message: app.localization.paymentProcessing.err.paymentFailed
                            });
                            app.dispatcher.replace('summary', 'show', []);
                        });
                });
            }
        },
        cartWPFinalize3DS: function (response, ccaddress, ccaddress2, cccity, cczip, cccountry) {
            var actionPromise = null;
            try {
                response = JSON.parse(response)
                if (response.MD) {
                    response.MD = JSON.parse(atob(response.MD))
                } else {
                    response.MD = {}
                }
            } catch(e){
                response.MD={}
            }
            if (!response.PaRes) {
                app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                    title:app.localization.paymentProcessing.PPPostError,
                    message:response
                });
                app.dispatcher.replace('summary','show',[]);
                return
            }

            var params = {
                        WebFolioId: app.data.WebFolioId,
                        SessionId: app.data.SessionId,
                        WPToken3DS: typeof response.MD.Token3DS != "undefined" ? response.MD.Token3DS : '',
                        WPPaRes:  typeof response.PaRes != "undefined" ? response.PaRes : '',
                        WPMD: JSON.stringify(response.MD)
                    }
            if (!actionPromise) {
                if (app.data.calledDoCheckout&&app.data.calledDoCheckout[app.data.WebFolioId]) {
                    if (app.data.calledDoCheckout[app.data.WebFolioId]=='success') {
                        actionPromise = $.Deferred().resolve().promise()
                    } else {
                        actionPromise = $.Deferred().reject().promise()
                    }
                } else {
                    actionPromise = app.models.systemModel.getData('doCheckout', params)
                }
            }
            $.when(actionPromise)
                .done(function (r_fb) {
                    app.data.calledDoCheckout = app.data.calledDoCheckout || {}
                    app.data.calledDoCheckout[app.data.WebFolioId] = 'success'
                    app.datac('calledDoCheckout', app.data.calledDoCheckout)
                    app.data.receipt = r_fb.Receipt ? r_fb.Receipt : false;
                    app.views.cartView.event.fire('showCCPaymentResult', [r_fb]);
                    app.views.cartView.event.fire('showPPProgressIndicator', [app.localization.paymentProcessing.PPPostRedirect]);
                    app.dispatcher.dispatch('summary','cartCheckout',["1"]);
                })
                .fail(function (r_fb) {
                    var message = (r_fb && r_fb.Receipt) ? app.localization.paymentProcessing.receiptHeader + r_fb.Receipt + app.localization.paymentProcessing.receiptFooter
                                                    : (r_fb.Result && r_fb.Result.Text)
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                    title:app.localization.paymentProcessing.PPPostError,
                                    message:message
                                });
                    app.dispatcher.replace('summary','show',[]);
                });
        },
        cartYPSubmit: function (ccfname, cclname, ccaddress1, ccaddress2, cccity, ccstate, cczip, cccountry) {
            app.views.cartView.event.fire('showYPProgressIndicator');
            $.when(app.models.systemModel.getData('setupYPPayment', {
                CustomerId: app.data.CustomerId,
                WebFolioId: app.data.WebFolioId
            }))
                    .done(function (r_fb) {
                        if (!!r_fb.RedirectURL) {
                            app.views.cartView.event.fire('redirectYP', [r_fb, ccfname, cclname, ccaddress1, ccaddress2, cccity, ccstate, cczip, cccountry]);
                        } else {
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                            title:app.localization.paymentProcessing.PPPreError,
                                            message:'(1)'
                                        });
                            app.dispatcher.replace('summary','ypPayment',[]);
                        }
                    })
                    .fail(function (r_fb) {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                        title:app.localization.paymentProcessing.PPPreError,
                                        message:'(2)'
                                    });
                        app.dispatcher.replace('summary','ypPayment',[]);
                    });

        },

        checkout: function (extra) {
            app.models.systemModel.validatePMSBeforeSpa().done(function(r_pbs){
                if (app.customization.roomsBooking.guestNoteSpecialServiceMandatory ) {
                    var folioBookings = app.models.systemModel.dataModel.folioBookings.data[
                                            app.models.roomsModel.makeStandardName(app.models.systemModel.dataModel.folioBookings,{})
                                        ]
                    var showError = (
                        folioBookings
                        && _.isArray(folioBookings.WebFolioItem)
                        &&  (!_.any(folioBookings.WebFolioItem, function(webFolioItem){
                            return  (    // If we don't have any of the items in the first !() half, then we return true because either there are no guest notes
                                     // or we can't determine whether there are missing mandatory guest notes.
                                     // otherwise the second half needs to be true (ie have a guest note special service) in order for the function
                                     // to return true
                                    !(
                                        webFolioItem.pmsVenue
                                        && webFolioItem.pmsVenue.GuestNoteServiceName
                                        && webFolioItem.specialServicesAvailable
                                        && _.any(webFolioItem.specialServicesAvailable, function(specialService){
                                            return specialService.PMSSpecialServiceName == webFolioItem.pmsVenue.GuestNoteServiceName
                                        })
        
                                    )
                                ||
                                    (
                                    webFolioItem.specialServices
                                    && _.any(webFolioItem.specialServices, function(specialService){
                                            return specialService.PMSSpecialService
                                                && specialService.PMSSpecialService.PMSSpecialServiceName == webFolioItem.pmsVenue.GuestNoteServiceName
                                        })
                                    )
                                )
                            })
                            )
                    ) 
        
                    if(!showError && app.customization.roomsBooking.guestNoteSpecialServiceMandatory) {
                        showError = folioBookings.WebFolioItem.some(function(webFolioItem){
                            if( webFolioItem.pmsVenue 
                                && webFolioItem.pmsVenue.GuestNoteServiceName == "Special Requests" 
                                && webFolioItem.specialServices.some(function(specialService){
                                    return specialService.PMSSpecialService
                                            && specialService.PMSSpecialService.PMSSpecialServiceName == webFolioItem.pmsVenue.GuestNoteServiceName
                                })
                            ) {
                                return (
                                    webFolioItem.specialServices
                                    && !webFolioItem.specialServices.some(function(specialService){
                                        // if(specialService.PMSSpecialService.PMSSpecialServiceName == "Special Requests"){
                                        //     return specialService.GuestNote.length == 0;
                                        // }
                                        return specialService.PMSSpecialService.PMSSpecialServiceName == "Special Requests";
                                    })
                                )
                            }
                            return false;
                        })
                    }
              
                    if(showError) {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                        title:app.localization.roomReservation.specialService.mandatory,
                                        message:''
                                    });
                        app.dispatcher.replace('summary','',[]);
                        return;
                    }
                }
                var  dfd = $.Deferred(),
                dfd2 = $.Deferred(),
                dfdSummary = $.Deferred(),
                dfdAuth = $.Deferred(),
                dfdAuth2 = $.Deferred(),
                dfd3 = [],
                deferreds = []  
                dfd3.push(dfdSummary)

                // Third Party Authentication Profile Required Fields Checking Starts Here
                dfd3.push(dfdAuth);
                // Combine 2 seperate profile checking settings into one
                var isGuestUser = app.datac('guestUser');
                var authProfileCheckRequired = app.customization.auth && app.customization.auth.requiredFieldsBeforeCheckout && app.customization.auth.requiredFieldsBeforeCheckout.length && !isGuestUser;  // skip this if guest user
                var skiProfileCheckRequired = app.customization.skiBooking.guestProfileUpdateOnCheckout && app.customization.skiBooking.requiredSkiFields.length && app.data.GuestsWithSkiInCart && !_.isEmpty(app.data.GuestsWithSkiInCart);

                if((authProfileCheckRequired || skiProfileCheckRequired) && !app.data.userLoggedIn) {
                    app.dispatcher.replace('profile','login',['next','summary','checkout',extra]);
                    return;
                }

                if(authProfileCheckRequired){
                    var fetchedGuestProfile = false; //avoid repeated fetch

                    var requiredProfileFields =  app.customization.auth.requiredFieldsBeforeCheckout;
                    var requiredSkiFields =  app.customization.skiBooking.requiredSkiFields;
                    var missingFields = [];

                    function checkAddressField (adrs){
                        var addressFilled = true;
                        _.each(adrs, function(addressPart, addressName){
                            if(addressName == 'Address1' || addressName == 'City' || addressName == 'Country' || addressName == 'PostCode'){
                                if(!addressPart.trim().length){
                                    addressFilled = false;
                                }
                            }
                        })
                        return addressFilled;
                    }

                    deferreds.push(dfdAuth2);

                    $.when(app.models.userModel.getData('fetchCustomerProfile', {
                        CustomerId: app.data.CustomerId,
                        CustomerGUID: app.data.CustomerGUID
                    })).always(function (customer) {
                        var profile = customer.Customer[0];
                        // Check if profile mssing any fields from customization settings
                        _.each(requiredProfileFields, function(field){
                            if(field.field == 'Address'){
                                var addressFieldFilled = false; 
                                var profileAddresses =  profile.Address;
                                _.each(profileAddresses, function(addres){
                                    if(checkAddressField(addres)){
                                        addressFieldFilled = true;
                                    }
                                })

                                if(!addressFieldFilled){
                                    missingFields.push({field: 'Address', name:field.field});
                                }
                            }

                            if(field.field == 'Salutation'){
                                var profileSalutation = profile.Name.Salutation;
                                if(!profileSalutation.trim().length){
                                    missingFields.push(field);
                                }
                            }

                            if(field.field == 'Gender'){
                                var profileGender = profile.Gender;
                                if(!profileGender.trim().length){
                                    missingFields.push(field);
                                }
                            }

                            if(field.field == 'Phone'){
                                var profilePhones = profile.Phone;
                                var noPhoneInfoExist = true;
                                _.each(profilePhones, function(phoneDetail){
                                    if( phoneDetail.PhoneNumber && phoneDetail.PhoneNumber.trim().length){
                                        noPhoneInfoExist = false;
                                    } else if (phoneDetail.PhoneData && phoneDetail.PhoneData.PhoneNumber.trim().length){
                                        noPhoneInfoExist = false;
                                    }
                                })

                                if(noPhoneInfoExist){
                                    missingFields.push(field);
                                }
                            }

                            if(field.field == 'DateOfBirth'){
                                var profileDOB = profile.DateOfBirth;
                                if(!profileDOB.trim().length){
                                    missingFields.push(field);
                                }
                            }
                        })
                        // Check if also missing any ski fields
                        if(skiProfileCheckRequired){
                            _.each(app.data.GuestsWithSkiInCart, function (details, customerId) {
                                if (customerId == app.data.CustomerId) {
                                    if (profile) {
                                        profile.SkiSettings['DateOfBirth'] = profile.DateOfBirth
                                        profile.missingSkiFields = getMissingFields(requiredSkiFields, profile.SkiSettings)
                                        app.data.GuestsWithSkiInCart[profile.CustomerId] = _.assign(app.data.GuestsWithSkiInCart[profile.CustomerId],profile) 
                                    }
                                } else {
                                    deferreds.push(dfd2);
                                    var params = {
                                        CustomerId: app.data.CustomerId,
                                        CustomerGUID: app.data.CustomerGUID
                                    }
                                    !fetchedGuestProfile ? $.when(app.models.userModel.getData('fetchGroupMembers', params).always(function (x) {
                                        fetchedGuestProfile = true;
                                        if (x.GroupMember) {
                                            _.each(x.GroupMember, function (guestProfile) {
                                                if (app.data.GuestsWithSkiInCart[guestProfile.CustomerId]) {
                                                    guestProfile.SkiSettings['DateOfBirth'] = guestProfile.DateOfBirth //support dob also
                                                    guestProfile.missingSkiFields = getMissingFields(requiredSkiFields, guestProfile.SkiSettings)
                                                    app.data.GuestsWithSkiInCart[guestProfile.CustomerId] = _.assign(app.data.GuestsWithSkiInCart[guestProfile.CustomerId],guestProfile) 
                                                }
                                            })
                                        }
                                        dfd2.resolve();
                                    })) : ''
                                }
                            });
                        }

                        $.when.apply(this,deferreds).always(function(){
                            if(skiProfileCheckRequired){
                                var requireProfile =  app.commonViewHelper.handleSkiLoopPerUserProfile('', '', missingFields)   //user found with the missing fields   
                                if(!requireProfile){
                                    dfdAuth.resolve();
                                    resolveToTermsModal();
                                } 
                            } else if(missingFields.length){
                                app.commonViewHelper.authProfileChecker(missingFields);  //user found with the missing fields  
                                return; 
                            } else {
                                dfdAuth.resolve();
                                resolveToTermsModal();
                            }
                        })
    
                        dfdAuth2.resolve()
                    })
                } else if(skiProfileCheckRequired) {
                    var fetchedGuestProfile = false //avoid repeated fetch
                    var requiredSkiFields =  app.customization.skiBooking.requiredSkiFields
                  
                    _.each(app.data.GuestsWithSkiInCart, function (details, customerId) {
                        if (customerId == app.data.CustomerId) {
                            deferreds.push(dfd);
                            $.when(app.models.userModel.getData('fetchCustomerProfile', {
                                CustomerId: app.data.CustomerId,
                                CustomerGUID: app.data.CustomerGUID
                            })).always(function (customer) {
                                var profile = customer.Customer[0]
                                if (profile) {
                                    profile.SkiSettings['DateOfBirth'] = profile.DateOfBirth
                                    profile.missingSkiFields = getMissingFields(requiredSkiFields, profile.SkiSettings)
                                     app.data.GuestsWithSkiInCart[profile.CustomerId] = _.assign(app.data.GuestsWithSkiInCart[profile.CustomerId],profile) 
                                }
                                dfd.resolve()
                            })
                        } else {
                            deferreds.push(dfd2);
                            var params = {
                                CustomerId: app.data.CustomerId,
                                CustomerGUID: app.data.CustomerGUID
                            }
                            !fetchedGuestProfile ? $.when(app.models.userModel.getData('fetchGroupMembers', params).always(function (x) {
                                fetchedGuestProfile = true;
                                if (x.GroupMember) {
                                    _.each(x.GroupMember, function (guestProfile) {
                                        if (app.data.GuestsWithSkiInCart[guestProfile.CustomerId]) {
                                            guestProfile.SkiSettings['DateOfBirth'] = guestProfile.DateOfBirth //support dob also
                                            guestProfile.missingSkiFields = getMissingFields(requiredSkiFields, guestProfile.SkiSettings)
                                            app.data.GuestsWithSkiInCart[guestProfile.CustomerId] = _.assign(app.data.GuestsWithSkiInCart[guestProfile.CustomerId],guestProfile) 
                                        }
                                    })
                                }
                                dfd2.resolve();
                            })) : ''
                        }
                    });
                    $.when.apply(this,deferreds).always(function(){
                        var requireProfile =  app.commonViewHelper.handleSkiLoopPerUserProfile()   //user found with the missing fields   
                        if(!requireProfile) {
                            dfdAuth.resolve();
                            resolveToTermsModal();
                        }
                    })
                } else {
                    dfdAuth.resolve();
                    resolveToTermsModal();
                }
                
                function getMissingFields(requiredSkiFields,guestSkiSettings){
                    return  _.filter(requiredSkiFields,function(y){ return !guestSkiSettings[y.field]});
                };             
                
                function resolveToTermsModal() {
                    dfdSummary.resolve();
                    var folioBookingsData = app.models.systemModel.dataModel.folioBookings.data[app.models.roomsModel.makeStandardName(app.models.systemModel.dataModel.folioBookings,{})]
        
                    dfd3.push(app.commonViewHelper.resolveCustomization(app.customization.payment.requireExplicitTermsAccept, {folioBookingsData:folioBookingsData, type:'cart'} ));
        
                    $.when.apply(this, dfd3).always(function(summaryResult,authDefResult, termsResult){
                        if (termsResult && (app.data.termsAccepted == 'undefined' || !app.data.termsAccepted)) {
                            //passing this to avoid filling required fields for guest flow
                            var isGuest = extra;
                            app.views.cartView.event.fire('showTermsModal', [isGuest]);
                        return;
                        }
        
                        if (!app.data.userLoggedIn) {
                            app.dispatcher.replace('profile','login',['next','summary','checkout',extra]);
                            return;
                        }
                        if (app.customization.hideOtherPropertyIfItemsInCart && (app.data.spaPropertyIdsInCart.length > 1 || app.data.pmsPropertyIdsInCart.length > 1 ||
                                ( app.data.spaPropertyIdsInCart.length == 1 && app.data.pmsPropertyIdsInCart.length == 1 && app.data.spaPropertyIdsInCart[0] != app.data.pmsPropertyIdsInCart[0] )
                            )) {
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                            title:app.localization.general.err.multipleProperties,
                                            message:''
                                        });
                            app.dispatcher.replace('summary','',[]);
                            return;
                        }
                        if (r_pbs && extra != "override" && !app.data.overridePMSRestriction) {
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                            title:app.localization.spaBooking.pmsbeforespa.errorMotice,
                                            message:''
                                        });
                            // app.data.messages.push({ type:'alert', 'class':'alert-notice', actions:[],
                            //                 title: app.localization.spaBooking.pmsbeforespa.acknowledgeTitle,
                            //                 message: app.localization.spaBooking.pmsbeforespa.acknowledgeIntro,
                            //                 actions: [{ text : app.localization.spaBooking.pmsbeforespa.acknowledgeText,
                            //                             loading : app.localization.spaBooking.pmsbeforespa.acknowledgeButton,
                            //                             label : app.localization.spaBooking.pmsbeforespa.acknowledgeButton,
                            //                             url : "#/summary/checkout/override" }]
                            //             });
                            app.dispatcher.replace('summary','',[]);
                            return;
                        }
                        var balance = app.models.systemModel.getSelectedValue('folioBalance','FolioBalance',{WebFolioId:app.data.WebFolioId,SessionId:app.data.SessionId});
        
        
                        if (
                                app.customization.skipPayment
                                ||
                                (
                                    (balance == "0.00" || balance == "0")
                                    && (
                                            app.customization.roomsBooking.forcePayment != true
                                            && (
                                                app.customization.payment.skipGuaranteeIfZeroBalanceAndGCUsed
                                                && app.data.redeemedGCs
                                                && app.data.redeemedGCs[app.data.WebFolioId]
                                                && app.data.redeemedGCs[app.data.WebFolioId].length
                                                )
                                        )
                                )
                            ) {
                            var checkoutDfd = $.Deferred();
                            app.controllers.cartController.prepBeforeDoCheckout(checkoutDfd.promise()).always(function(prepSuccess){
                                if (prepSuccess) {
                                    checkoutDfd.resolve();
                                    app.dispatcher.dispatch('summary','cartCheckout',["1"])
                                    console.log('pay skipped');
                                }
                            });
                        } else {
                            $.when(app.models.systemModel.getData('setCheckout', { /* ThirdPartyPayEngine: "Google"  ThirdPartyPayEngine P_LONGSTRING6, CreateToken P_LONGSTRING5  */ }))
                                .done(function (r_sc) {
                                    if (app.customization.payment.skipCCifGuaranteed && (balance == "0.00" || balance == "0") && r_sc.Guaranteed == "Y" && app.customization.roomsBooking.forcePayment != true) {
        //                            if ( (((balance == "0.00" || balance == "0") && r_sc.Guaranteed == "Y")||r_sc.NPR=="Y") && app.customization.roomsBooking.forcePayment != true) {
                                        var checkoutDfd = $.Deferred();
                                        app.controllers.cartController.prepBeforeDoCheckout(checkoutDfd.promise()).always(function(prepSuccess){
                                            if (prepSuccess) {
                                                checkoutDfd.resolve();
                                                app.dispatcher.dispatch('summary','cartCheckout',["1"])
                                                if (r_sc.NPR=="Y") {
                                                    console.log('pay skipped due to NPR flag');
                                                } else {
                                                    console.log('pay skipped due to Guaranteed and bal zero');
                                                }
                                            }
                                        });
                                        return;
                                    }
                                    $.cookie('sessionid', app.data.SessionId, {expires: Date.now().add(+app.customization.defaultSessionTimeout).minutes()});
                                    app.data.calledDoCheckout = app.data.calledDoCheckout || {}
                                    delete app.data.calledDoCheckout[app.data.WebFolioId]
                                    app.datac('calledDoCheckout', app.data.calledDoCheckout)
                                    if (r_sc.PaymentEngine=="YPAY") {
                                        app.dispatcher.dispatch('summary','ypPayment',[r_sc.MID, r_sc.MTR, r_sc.Digest,r_sc.Currency,r_sc.ForwardURL,r_sc.SuccessURL,r_sc.FailURL,r_sc.AllowStoreCard]);
                                    } else if (r_sc.PaymentEngine=="PAYTM") {
                                        app.dispatcher.dispatch('summary','paytmPayment',[r_sc.ForwardURL,r_sc.REQUEST_TYPE,r_sc.MID,r_sc.ORDER_ID,r_sc.CUST_ID,r_sc.TXN_AMOUNT,r_sc.CHANNEL_ID,r_sc.INDUSTRY_TYPE_ID,r_sc.WEBSITE,r_sc.MOBILE_NO,r_sc.EMAIL_ID,r_sc.CHECKSUMHASH,r_sc.CALLBACK_URL,r_sc.AllowStoreCard]);
                                    } else if (r_sc.PaymentEngine=="I4GO") {
                                        app.dispatcher.dispatch('summary','i4gPayment',[r_sc.ForwardURL,r_sc.AccessBlock,r_sc.Server,r_sc.AllowStoreCard]);
                                    } else if (r_sc.PaymentEngine=="WPAY") {
                                        app.dispatcher.dispatch('summary','wpPayment',[r_sc.ForwardURL,r_sc.WPCustomerId,r_sc.AllowStoreCard]);
                                    } else if (r_sc.PaymentEngine=="SQUARE-HOSTED") {
                                        app.dispatcher.dispatch('summary','sqPayment',[r_sc.ApplicationId,r_sc.ForwardURL,r_sc.LocationId,r_sc.ThreeDSEnabled,r_sc.PaymentAmount,r_sc.AllowStoreCard,r_sc.Currency]);
                                    } else if (r_sc.PaymentEngine=="3C") {
                                        app.dispatcher.dispatch('summary','3cPayment',[r_sc.ForwardURL,r_sc.AllowStoreCard,r_sc.PaymentAmount,r_sc.ThreeDSEnabled,r_sc.ThreeCSession]);
                                    } else if (r_sc.PaymentEngine=="S4" || r_sc.PaymentEngine== "SIMPLE" ) {
                                        app.dispatcher.dispatch('summary','ccPayment',[r_sc.AllowStoreCard]);
                                    } else if (r_sc.PaymentEngine=="PP") {
                                        app.dispatcher.dispatch('summary','ppPayment',[r_sc.AllowStoreCard]);
                                    } else if (r_sc.PaymentEngine=="FREEDOMPAY") {     // forwardURL,allowStoreCard,paymentamount,3dsenabled,applepayenabled,googlepayenabled,samsungpayenabled,paypalenabled
                                        app.dispatcher.dispatch('summary','fpPayment',[r_sc.ForwardURL,r_sc.AllowStoreCard,r_sc.PaymentAmount,r_sc.ThreeDSEnabled,r_sc.ApplePayEnabled,r_sc.GooglePayEnabled,r_sc.SamsungPayEnabled,r_sc.PayPalEnabled]);
                                    } else if (r_sc.Guaranteed=="Y"){
                                        app.dispatcher.dispatch('summary','cartCheckout',["1"])
                                    } else {
                                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                                    title:app.localization.paymentProcessing.PPPostError,
                                                    message:''
                                                });
                                        app.dispatcher.replace('summary','show',[]);
                                    }
                                })
                                .fail(function (r_sc) {
                                    if ((r_sc.Result.Text == "Invalid address: Address 1/Street is required.") || (r_sc.Result.Text == "Invalid address: City is required")) {
                                        app.data.messages.push({
                                            type: 'alert', 'class': 'alert-error', actions: [],
                                            title: app.localization.paymentProcessing.PPPostAddressRequired,
                                            message: ''
                                        });
                                        app.dispatcher.replace('summary', 'show', []);
                                    } else {
                                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                                        title:app.localization.paymentProcessing.PPPostError,
                                                        message:''
                                                    });
                                        app.dispatcher.replace('summary','show',[]);
                                    }
                                });
                        }
        
                    })
                 
                }
            });
        },
        setPMSRestrictionOverride: function() {
            app.datac('overridePMSRestriction', true);
            window.history.back();
        },
        eReg: function(venueName, pmsFolioId,lastname) {
            app.views.cartView.event.fire('renderERegForm', [venueName, pmsFolioId,lastname]);
        }

    })
});

